import jsPDF from "jspdf";
import React, { useEffect, useRef, useState, useCallback } from "react";
import ReactPaginate from "react-paginate";
import { jwtDecode } from "jwt-decode";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import medicGeekApi from "../../config/axiosConfig";
import {
  showConfirmationAlert,
  showErrorAlert,
  showSuccessAlert,
} from "./../../components/alerts";
import "./../../styles/scrollbar.css";
import "@fontsource/poppins"; // Importa la fuente
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/material_blue.css';  // O el tema que prefieras
import { Spanish } from 'flatpickr/dist/l10n/es.js';
import CalibriNormal from "./calibri-normal"; 
import CalibriBold from "./calibri-bold"; 
import TipTap from "../../styles/TipTap.css";
import ProRichTextEditor from "../../contexts/ProRichTextEditor";


const ConsultaForm = ({ paciente, onCloseForm, formulario }) => {
  const { pcteId, consultId } = useParams();
  const history = useNavigate();
  const [consultFec, setConsultFec] = useState("");
  const [consultMot, setConsultMot] = useState("");
  const [estatus, setEstatus] = useState("Activa");
  const [consultHea, setConsultHea] = useState("");
  const [consultMotOld, setConsultMotOld] = useState("");
  const [antOtros, setAntOtros] = useState("");
  const [antFarmacos, setAntFarmacos] = useState("");
  const [exam1, setExam1] = useState("");
  const [exam2, setExam2] = useState("");
  const [exam3, setExam3] = useState("");
  const [exam4, setExam4] = useState("");
  const [exam5, setExam5] = useState("");
  const [exam6, setExam6] = useState("");
  // const [exam7, setExam7] = useState('');
  const [exam8, setExam8] = useState("");
  const [exam9, setExam9] = useState("");
  const [exam10, setExam10] = useState("");
  const [exam11, setExam11] = useState("");
  const [exam12, setExam12] = useState("");
  const [exam13, setExam13] = useState("");
  const [exam14, setExam14] = useState("");
  const [exam15, setExam15] = useState("");
  const [exam16, setExam16] = useState("");
  const [exam17, setExam17] = useState("");
  const [exam18, setExam18] = useState("");
  const [examComentario, setExamComentario] = useState("");
  const [estGabinete, setEstGabinete] = useState("");
  const [consultDiag, setConsultDiag] = useState("");
  const [consultTipDiag, setConsultTipDiag] = useState("");
  const [consultClaDiag, setConsultClaDiag] = useState("");

  // Activar los tabs
  const [activeTab, setActiveTab] = useState("1");
  const [activeTabLab, setActiveTabLab] = useState("1");

  // Patologia
  const [tappctesData, setTappctesData] = useState({
    checke1: false,
    checke2: false,
    checke3: false,
    checke4: false,
    checke5: false,
    checke6: false,
    checke7: false,
    checke8: false,
    checke9: false,
    checke10: false,
    checke11: false,
    checke12: false,
    checke13: false,
    checke14: false,
    checke15: false,
    toxicChecke1: false,
    toxicChecke2: false,
    toxicChecke3: false,
    toxicOtros: "",
  });

  // Analisis
  const [resultLab, setResultLab] = useState("");

  const [analysisData, setAnalysisData] = useState([]);
  const [citasFiltradas, setCitasFiltradas] = useState([]);
  const [analysisValues, setAnalysisValues] = useState({
    analysis1: "0.00",
    analysis2: "0",
    analysis3: "0.00",
    analysis4: "0",
    analysis5: "0",
    analysis6: "0.00",
    analysis7: "0.00",
    analysis8: "0.00",
    analysis9: "0.00",
    analysis10: "0.00",
    analysis11: "0.00",
    analysis12: "0",
    analysis13: "0.00",
    analysis14: "0",
    analysis15: "0.00",
    analysis16: "0.00",
    analysis17: "0.00",
    analysis18: "0",
    analysis19: "0.00",
    analysis20: "0.00",
    analysis21: "0.00",
    analysis22: "0.00",
    analysis23: "0.00",
    analysis24: "0.00",
    analysis25: "0.00",
    analysis26: "0.00",
    analysis27: "0.00",
    analysis28: "0.00",
    analysis29: "0.00",
    analysis30: "0.00",
    analysis31: "0",
    analysis32: "0.00",
    analysis33: "0",
    analysis34: "0.00",
    analysis35: "0.00",

    analysis36: "",
    analysis37: "",
    analysis38: "",
    analysis39: "",

    analysis40: "",
    analysis41: "",
    analysis42: "",
    analysis43: "",
  });

  // Consultas
  const [consultas, setConsultas] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const isSavingRef = useRef(false);
  // Certificados
  const [certmedicos, setCertmedicos] = useState([]);

  // Recetas
  const [recetasOrdenadasPorConsulta, setRecetasOrdenadasPorConsulta] = useState([]);
  const [recetaActiva, setRecetaActiva] = useState(null);

  // Cruds
  const [externalCauses, setExternalCauses] = useState([]);
  const [causeId, setCauseId] = useState("1");

  // Acordion
  const [isAccordionDiagnosticoOpen, setIsAccordionDiagnosticoOpen] =
    useState(false);
  const [isAccordionCitaOpen, setIsAccordionCitaOpen] = useState(true);
  const [openAccordion, setOpenAccordion] = useState(null);

  // Agregar altura
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const [parentDivHeight, setParentDivHeight] = useState("18rem");
  const [alturaContenedorCita, setAlturaContenedorCita] = useState("40rem");
  const parentDivRef = useRef();
  const [expanded, setExpanded] = useState(false);

  // Contador de caracteres
  const maxChars1 = 5000;
  const maxChars2 = 2000;
  const maxChars3 = 500;
  const maxChars4 = 10000;

  // Nuevo estado para controlar si se están editando los campos
  const [isEditing, setIsEditing] = useState(false);

  // Buscador
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermMedic, setSearchTermMedic] = useState("");

  // Componente de visualizar Historico
  const [historicoVisible, setHistoricoVisible] = useState(false);
  const [ultimaConsulta, setUltimaConsulta] = useState({});
  const [ultimaConsultaAll, setUltimaConsultaAll] = useState(0);
  const [isEditingConsulta, setIsEditingConsulta] = useState(false);

  // Categoria
  const [categoryId, setCategoryId] = useState("1");
  const [categoryData, setCategoryData] = useState([]);
  const [payData, setPayData] = useState([]);
  const [ultimoPay, setUltimoPay] = useState([]);

  // Parametros para el Modal - Cie-10
  const [isModalCie10Open, setIsModalCie10Open] = useState(false);
  const [cie10Data, setCie10Data] = useState([]);
  const [consultCie10, setConsultCie10] = useState("");
  const [codeCie10, setCodeCie10] = useState();
  const [descriptionCie10, setDescriptionCie10] = useState("");
  const [selectedCIE10, setSelectedCIE10] = useState(null);
  const [isDescriptionCie10Editable, setIsDescriptionCie10Editable] =
    useState(true);

  // Modal para guardar consulta
  const [isSaveConsultModalOpen, setIsSaveConsultModalOpen] = useState(false);
  const [camposCompletos, setCamposCompletos] = useState(false);
  const [openModalSaveConsult, setOpenModalSaveConsult] = useState(false);

  // Modal para el resultado de Laboratorio
  const [openModalResultadoLab, setOpenModalResultadoLab] = useState("");

  // Paginacion
  const consultasPerPage = 5;
  const certMedicosPerPage = 5;
  const recetasMedicosPerPage = 5;
  const [pageNumber, setPageNumber] = useState(0);
  const [pageNumberCertMedicos, setPageNumberCertMedicos] = useState(0);
  const [pageNumberRecetaMedicos, setPageNumberRecetaMedicos] = useState(0);
  const pageCountConsult = Math.ceil(consultas.length / consultasPerPage);
  const pageCountCertMedicos = Math.ceil(certmedicos.length / certMedicosPerPage);

//   const pageCountRecetasMedicos = Math.ceil(
//   recetasArray.length / recetasMedicosPerPage
// );
  // const pageCountConsultList = Math.ceil(consultas.length / consultasPerPage);

  const itemsPerPage = 10;
  const pagesVisited = pageNumber * itemsPerPage;
  const pageCount = Math.ceil(cie10Data.length / itemsPerPage);

  const [currentPage, setCurrentPage] = useState(0);

  // Recetas Medicas
  const [dosis, setDosis] = useState("");
  const [total, setTotal] = useState("");
  const [medicamentos, setMedicamentos] = useState([]);
  const [showMedicamentosModal, setShowMedicamentosModal] = useState(false);
  const [medicamentosSearchResults, setMedicamentosSearchResults] = useState(
    []
  );
  const [isMedicamentosModalOpen, setIsMedicamentosModalOpen] = useState(false);
  const [descripcionMedicamento, setDescripcionMedicamento] = useState("");
  const [dosisMedicamento, setDosisMedicamento] = useState("");
  const [recetaControlada, setRecetaControlada] = useState("");
  const [medicamentoEditIndex, setMedicamentoEditIndex] = useState(null); // Para identificar si es edición

  // Agendar Cita
  const [fechaActual, setFechaActual] = useState("");
  const [fechaCita, setFechaCita] = useState("");
  const [horaCita, setHoraCita] = useState("");
  const [horaFormateada, setHoraFormateada] = useState("");
  const [notaCita, setNotaCita] = useState("");
  const [categoryCitaId, setCategoryCitaId] = useState("");
  const [isSwift, setIsSwift] = useState(false); // Ajusta el valor inicial según tu lógica

  // Procesar Pago
  const [cantidadPago, setCantidadPago] = useState("");
  const [descripcionPago, setDescripcionPago] = useState("");

  const [fechaConsulta, setFechaConsulta] = useState("");

  // Pantalla de Carga
  const [isLoading, setIsLoading] = useState(false); // Estado de carga
  const [profileData, setProfileData] = useState(null);

  const [recetas, setRecetas] = useState([]);
  const [sortedRecetas, setSortedRecetas] = useState([]);

  const [pageNumberRecetas, setPageNumberRecetas] = useState(0);
  const recetasPerPage = 10;

  const pageCountRecetas = Math.ceil(
    Object.values(recetas).length / recetasPerPage
  );

  const [mensajeConsulta, setMensajeConsulta] = useState("");
  const [mensajeAntecedentes, setMensajeAntecedentes] = useState("");


  const [modalRecetaOpen, setModalRecetaOpen] = useState(false);
  const [selectedReceta, setSelectedReceta] = useState(null);
  const [fechaConsultaSeleccionada, setFechaConsultaSeleccionada] =
    useState(null);

  const searchInputRef = useRef(null);
  const montoRef = useRef(null);
  const datePickerRef = useRef(null);

  // Modal de resumen clinico
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedConsulta, setSelectedConsulta] = useState(null);
  const [modalCertificadoOpen, setModalCertificadoOpen] = useState(false);
  const [selectedCertificado, setSelectedCertificado] = useState(null);
  

  useEffect(() => {
   
    fetchProfile();
    fetchData();
  }, [paciente, isAccordionOpen, pcteId, consultId, formulario]);

  useEffect(() => {
    // Inicializar Flatpickr
    if (datePickerRef.current) {
      Flatpickr(datePickerRef.current, {
        defaultDate: fechaCita || new Date(),
        onChange: handleFechaCitaChange,
        locale: {
          ...Spanish,
          firstDayOfWeek: 0,
        },
        dateFormat: 'd/m/Y',
        onDayCreate: (dObj, dStr, fp, dayElem) => {
          // Obtener el día de la semana (0 = domingo, 6 = sábado)
          const day = dayElem.dateObj.getDay();
          if (day === 0 || day === 6) {
            // Aplicar clase CSS para sábado y domingo
            dayElem.classList.add('highlight-weekend');
          }
        },
      });
    }
  }, [fechaCita]);

  useEffect(() => {
    if (openModalSaveConsult) {
      setTimeout(() => {
        if (searchInputRef.current) {
          searchInputRef.current.focus();
        }
      }, 300); // 300 ms es suficiente para asegurar el renderizado del modal
    }
  }, [openModalSaveConsult]);
  

  const fetchData = async () => {
    try {

      setIsLoading(true);
      // Llamadas a los endpoints independientes del paciente
      const [
        consultAllResponse,
        externalCauseResponse,
        categoryResponse,
        paysResponse,
        cie10Response,
        recetasResponse
      ] = await Promise.all([
        medicGeekApi.get("/consults"),
        medicGeekApi.get("/externalCauses"),
        medicGeekApi.get("/categorys"),
        medicGeekApi.get("/pays"),
        medicGeekApi.get("/cie10s"),
        medicGeekApi.get("/recetas/"),
      ]);
  
      // Axios automáticamente parsea la respuesta JSON
      const consultAllData = consultAllResponse.data;
      const externalCauseData = externalCauseResponse.data.filter(
        (cause) => cause.estatus === "Activo"
      );
      const categoryData = categoryResponse.data.filter(
        (category) => category.estatus === "Activo"
      );
      const paysData = paysResponse.data;
      const cie10DataResponse = cie10Response.data;
  
      // Ultimo pago
      const ultimoPay = paysData.length + 1;
      // Consultar la última consulta de todas y sumarle 1
      const ultimaConsultaAll = consultAllData.length + 1;
  
      // Establecer estados correspondientes
      setCie10Data(cie10DataResponse);
      setExternalCauses(externalCauseData);
      setCategoryData(categoryData);
      setUltimoPay(ultimoPay);
      setUltimaConsultaAll(ultimaConsultaAll);
  
      // Llamadas a los endpoints relacionados con el paciente
      if (!paciente || !paciente.pcteId) {
        console.error("Error: El paciente no tiene un ID definido.");
        setIsLoading(false);
        return;
      }
      setSortedRecetas(sortedRecetas);
      
      const displayedRecetas = sortedRecetas.map((receta) => {
        const medicId = receta.medicId;
        const medicNm = receta.medicNm;
        return { medicId, medicNm };
      });
  
      const [
        consultPcteResponse,
        tappctesResponse,
        analysisDataResponse,
        citasDataResponse,
        certmedicosDataResponse,
      ] = await Promise.all([
        medicGeekApi.get(`/consults/by-paciente/${paciente.pcteId}`),
        medicGeekApi.get(`/tappctes/by-paciente/${paciente.pcteId}`),
        medicGeekApi.get(`/analysis/by-paciente/${paciente.pcteId}`),
        medicGeekApi.get(`/calendars/detail`),
        medicGeekApi.get(`/certmedicos/by-paciente/${paciente.pcteId}`),
      ]);
  
      // Acceder a los datos directamente desde las respuestas
      const consultData = consultPcteResponse.data;
      const tappctesData = tappctesResponse.data;
      const analysisData = analysisDataResponse.data;
      const citasData = citasDataResponse.data;
      const certmedicosData = certmedicosDataResponse.data;
      const citasFiltradas = citasData.filter(
        (cita) => cita.pcteId === paciente.pcteId && cita.estatus === "Activo"
      );

      // Cargar las recetas en Resumen Clinico
      const recetasData =  recetasResponse.data;
      const consultIdsPaciente = new Set(
        consultData.map(c => Number(c.consultId))
      );
      // Filtrar y agrupar recetas por consultId
      const recetasPaciente = recetasResponse.data.filter(receta =>
        consultIdsPaciente.has(Number(receta.consultId))
      );
      
      // Agrupar recetas por consultId
      const recetasPorConsultId = recetasPaciente.reduce((acc, receta) => {
        const id = receta.consultId;
        if (!acc[id]) acc[id] = [];
        acc[id].push(receta);
        return acc;
      }, {});

      const recetasOrdenadasPorConsultaLocal = Object.entries(recetasPorConsultId)
      .sort((a, b) => Number(b[0]) - Number(a[0]))
      .map(([, value]) => value)
      .flat();
      setRecetas(recetasPorConsultId);
      setRecetasOrdenadasPorConsulta(recetasOrdenadasPorConsultaLocal);


      
      // Convertir el objeto a un array y ordenar por consultId descendente
      const sortedRecetasLocal = Object.entries(recetasPorConsultId)
        .sort((a, b) => Number(b[0]) - Number(a[0]))
        .map(([, value]) => value)
        .flat();

      setRecetas(recetasPorConsultId);
      setSortedRecetas(sortedRecetasLocal);
  
      if (parentDivRef.current) {
        setParentDivHeight(`${parentDivRef.current.scrollHeight}px`);
      }

      if (consultData && consultData.length > 0) {
        // Ordenar las consultas por la fecha en orden descendente (más reciente primero)
        const sortedConsultData = consultData.sort(
          (a, b) => b.consultId - a.consultId
        );

        const ultimaConsulta = sortedConsultData[0];  // Obtener la consulta más reciente
        setConsultas(sortedConsultData);
        setCertmedicos(certmedicosData);
        setUltimaConsulta(ultimaConsulta);
        setAnalysisData(analysisData);
        setCitasFiltradas(citasFiltradas);
        
        if (ultimaConsulta) {
          setConsultMotOld(ultimaConsulta.consultMot || "");
          setConsultClaDiag(ultimaConsulta.consultClaDiag || "");
          setConsultTipDiag(ultimaConsulta.consultTipDiag || "");
          setConsultDiag(ultimaConsulta.consultDiag || "");
          setCauseId(ultimaConsulta.causeId || "");
          setCategoryId(ultimaConsulta.categoryId || "");
        } else {
          console.warn("No se encontró última consulta válida.");
        }

        setFechaActual(fechaActualFormateada);
      } else {
        console.warn("No se encontraron antecedentes patológicos.");
        // Mostrar un mensaje amigable en la interfaz
        setMensajeAntecedentes("No hay antecedentes patológicos disponibles para este paciente.");
      }
      
      
      if (tappctesData.length > 0) {
        const ultimoTappctes = tappctesData[tappctesData.length - 1];
      
        setTappctesData({
          checke1: ultimoTappctes.checke1,
          checke2: ultimoTappctes.checke2,
          checke3: ultimoTappctes.checke3,
          checke4: ultimoTappctes.checke4,
          checke5: ultimoTappctes.checke5,
          checke6: ultimoTappctes.checke6,
          checke7: ultimoTappctes.checke7,
          checke8: ultimoTappctes.checke8,
          checke9: ultimoTappctes.checke9,
          checke10: ultimoTappctes.checke10,
          checke11: ultimoTappctes.checke11,
          checke12: ultimoTappctes.checke12,
          checke13: ultimoTappctes.checke13,
          checke14: ultimoTappctes.checke14,
          checke15: ultimoTappctes.checke15,
          antOtros: ultimoTappctes.antOtros,
          mquirur: ultimoTappctes.mquirur,
          malergi: ultimoTappctes.malergi,
          mtrauma: ultimoTappctes.mtrauma,
          mtransf: ultimoTappctes.mtransf,
          mmadre: ultimoTappctes.mmadre,
          mpadre: ultimoTappctes.mpadre,
          mconyu: ultimoTappctes.mconyu,
          motros: ultimoTappctes.motros,
          antFarmacos: ultimoTappctes.antFarmacos,
          toxicChecke1: ultimoTappctes.toxicChecke1,
          toxicChecke2: ultimoTappctes.toxicChecke2,
          toxicChecke3: ultimoTappctes.toxicChecke3,
          toxicOtros: ultimoTappctes.toxicOtros,
        });
      } else {
        console.error(
          "No hay consultas o antecedentes patológicos disponibles."
        );
      }

    } catch (error) {
      console.error("Error al recuperar las consultas:", error.message);
    }
    finally {
      setIsLoading(false); // Ocultar pantalla de carga cuando termine
    }
  };

  const fetchProfile = async () => {
    try {
      // Obtener el token desde localStorage
      const token = localStorage.getItem("token");
      if (token) {
        // Decodificar el token para obtener el nombre de usuario
        const decodedToken = jwtDecode(token);
        const username = decodedToken.username; // Asegúrate de que 'username' sea correcto

        if (username) {
          // Buscar perfil por nombre de usuario
          const response = await medicGeekApi.get(`/profile/user/${username}`);
          const data = response.data;

          // Verificar si se recibió el perfil
          if (data) {
            setProfileData(data);
            setIsEditing(true);
          } else {
            console.error("No se encontró el perfil del usuario.");
          }
        } else {
          console.error("No se pudo obtener el nombre de usuario del token.");
        }
      } else {
        console.error("No se encontró el token.");
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const toggleTabLab = (tab) => {
    if (activeTabLab !== tab) setActiveTabLab(tab);
  };

  const obtenerFechaActual = () => {
    const fechaActual = new Date();
    const dia = String(fechaActual.getDate()).padStart(2, "0");
    const mes = String(fechaActual.getMonth() + 1).padStart(2, "0"); // El mes se cuenta desde 0, por eso se suma 1
    const anio = fechaActual.getFullYear();
    return `${dia}/${mes}/${anio}`;
  };
  const fechaActualFormateada = obtenerFechaActual();

  function formatearFecha(fecha) {
    const dia = fecha.getDate().toString().padStart(2, "0");
    const mes = (fecha.getMonth() + 1).toString().padStart(2, "0");
    const año = fecha.getFullYear();
    return `${dia}/${mes}/${año}`;
  }

  function formatearHora(fecha) {
    const ampm = fecha.getHours() >= 12 ? "PM" : "AM";
    let horas = fecha.getHours() % 12;
    horas = horas === 0 ? 12 : horas;
    const minutos = fecha.getMinutes();
    const horaFormateada = `${horas.toString().padStart(2, "0")}:${minutos
      .toString()
      .padStart(2, "0")} ${ampm}`;
    return horaFormateada;
  }

  function formatearFechaCita(fecha) {
    const dia = (fecha.getDate()).toString().padStart(2, "0");
    const mes = (fecha.getMonth() + 1).toString().padStart(2, "0"); // Ajusta el mes sumando 1
    const año = fecha.getFullYear();
    return `${dia}/${mes}/${año}`;
  }

  function formatearHora12Horas(horaFormateada) {
    const [hora, minutos] = horaFormateada.split(":");
    const horaNumero = parseInt(hora);

    // Función auxiliar para agregar un cero delante de números menores que 10
    const agregarCero = (numero) => (numero < 10 ? `0${numero}` : `${numero}`);

    if (horaNumero === 0) {
      return `12:${minutos} AM`;
    } else if (horaNumero < 12) {
      return `${agregarCero(horaNumero)}:${minutos} AM`;
    } else if (horaNumero === 12) {
      return `12:${minutos} PM`;
    } else {
      return `${agregarCero(horaNumero - 12)}:${minutos} PM`;
    }
  }

  // Función para formatear la fecha y hora en el formato deseado
  function formatearFechaHora(fecha) {
    const dia = fecha.getDate().toString().padStart(2, "0");
    const mes = fecha.getMonth() + 1;
    const año = fecha.getFullYear();

    // Formatea la hora con AM/PM
    const horaFormateada = formatearHora(fecha);

    return `${dia}/${mes}/${año} ${horaFormateada}`;
  }

  // Sixe
  const handleToggleSize = () => {
    setExpanded(!expanded);
  };

  const toggleHistorico = () => {
    setHistoricoVisible(!historicoVisible);
  };

  // Nueva función para manejar el cambio de página
  const handlePageChange = ({ selected }) => {
    setPageNumber(selected);
  };

  const handlePageChangeCertMedicos = ({ selected }) => {
    setPageNumberCertMedicos(selected);
  };

  const handlePageChangeRecetaMedicos = ({ selected }) => {
    setPageNumberRecetaMedicos(selected);
  };

  const handleAccordionToggle = (accordionId) => {
    setOpenAccordion(openAccordion === accordionId ? null : accordionId);
  };

  const groupRecetasByConsultId = (recetasData) => {
    const recetasPorConsultId = {};

    // Iterar sobre cada receta
    recetasData.forEach((receta) => {
      // Obtener el consultId de la receta
      const consultId = receta.consultId;

      // Si ya existe una entrada para este consultId, agregar la receta a la lista existente
      if (recetasPorConsultId[consultId]) {
        recetasPorConsultId[consultId].push(receta);
      } else {
        // Si no existe una entrada para este consultId, crear una nueva lista con esta receta
        recetasPorConsultId[consultId] = [receta];
      }
    });

    return recetasPorConsultId;
  };

  const displayedConsultas = consultas
  .sort((a, b) => b.consultId - a.consultId) // Orden descendente por consultId
  .slice(pageNumber * consultasPerPage, (pageNumber + 1) * consultasPerPage);

  const displayedCertMedicos = certmedicos
  .sort((a, b) => b.certifiId - a.certifiId) // Orden descendente por consultId
  .slice(pageNumberCertMedicos * certMedicosPerPage, (pageNumberCertMedicos + 1) * certMedicosPerPage);

  //  Mostrar las recetas en Resumen Clinico
  const recetasArray = Array.isArray(recetas)
    ? recetas
    : Object.values(recetas || {});

  const recetasAgrupadas = Array.isArray(recetas)
    ? recetas
    : Object.values(recetas || {});

  const pageCountRecetasMedicos = Math.ceil(
    recetasAgrupadas.length / recetasMedicosPerPage
  );

  const startIdx =
    pageNumberRecetaMedicos * recetasMedicosPerPage;

  const endIdx =
    startIdx + recetasMedicosPerPage;

  const recetasOrdenadas = [...recetasAgrupadas].sort((a, b) => {
    const idA = Number(a?.[0]?.consultId) || 0;
    const idB = Number(b?.[0]?.consultId) || 0;

    return idB - idA; // 🔽 DESCENDENTE
  });

  const displayedRecetas =
  recetasOrdenadas.slice(startIdx, endIdx);

  const handleVerRecetaClick = ({ recetas, fechaConsulta, consultId }) => {
  setRecetaActiva({
    recetas,
    fechaConsulta,
    consultId,
  });
};

  // Modales
  const openModalCie10 = async () => {
    try {
      const response = await medicGeekApi.get("/cie10s");
      setCie10Data(response.data);
      setIsModalCie10Open(true);

      setTimeout(() => {
        if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, 100); // Un retraso corto
    } catch (error) {
      console.error("Error al cargar datos desde el endpoint:", error);
    }
  };

  const handleCIE10Selection = (selectedItem) => {
    setDescriptionCie10(selectedItem.description);
    setCodeCie10(selectedItem.code);
    setIsModalCie10Open(false);
  };

  const getCategoryName = (categoryId, categoryData) => {
    const categoriaSeleccionada = categoryData.find(
      (item) => item.categoryId === categoryId
    );
    return categoriaSeleccionada
      ? categoriaSeleccionada.categoryNm
      : "Categoría no encontrada";
  };

  // Mostrar antecedentes
  const tieneAntecedentes = () => {
    const antecedentes = [
      tappctesData.checke1,
      tappctesData.checke2,
      tappctesData.checke3,
      tappctesData.checke4,
      tappctesData.checke5,
      tappctesData.checke6,
      tappctesData.checke7,
      tappctesData.checke8,
      tappctesData.checke9,
      tappctesData.checke10,
      tappctesData.checke11,
      tappctesData.checke12,
      tappctesData.checke13,
      tappctesData.checke14,
      tappctesData.checke15,
    ];

    return antecedentes.some((antecedente) => antecedente);
  };

  const handleAnalysisChange = (fieldName, value) => {
    setAnalysisValues((prevValues) => ({
      ...prevValues,
      [fieldName]: value,
    }));
  };

  // Agregar Receta Medica
  const handleDoubleClickMedicamento = (index) => {
    const medicamentoSeleccionado = medicamentos[index];
    setDescripcionMedicamento(medicamentoSeleccionado.medicamento);
    setDosis(medicamentoSeleccionado.dosis);
    setTotal(medicamentoSeleccionado.total);
    setMedicamentoEditIndex(index); // Guardamos el índice del medicamento seleccionado
  };
  
  // Función para agregar o editar el medicamento
  const handleAddMedicamento = () => {

     // Validar si el campo de medicamento está vacío
    if (!descripcionMedicamento.trim()) {
      showErrorAlert("Por favor, ingrese un medicamento antes de agregar."); // Muestra una alerta si no hay medicamento
      return; // No continúa con el proceso si no hay medicamento
    }

    const nuevoMedicamento = {
      medicamento: descripcionMedicamento,
      dosis: dosis,
      total: total,
    };
  
    if (medicamentoEditIndex !== null) {
      // Si estamos editando, actualizamos el medicamento en lugar de agregar uno nuevo
      const medicamentosActualizados = [...medicamentos];
      medicamentosActualizados[medicamentoEditIndex] = nuevoMedicamento;
      setMedicamentos(medicamentosActualizados);
      setMedicamentoEditIndex(null); // Resetear el índice después de la edición
    } else {
      // Si no estamos editando, agregamos un nuevo medicamento
      setMedicamentos([...medicamentos, nuevoMedicamento]);
    }
  
    // Limpiar los inputs después de agregar o editar
    setDescripcionMedicamento("");
    setDosis("");
    setTotal("");
  };
  // eliminar medicamentos del listado
  const handleDeleteMedicamento = (index) => {
    const nuevosMedicamentos = [...medicamentos];
    nuevosMedicamentos.splice(index, 1);
    setMedicamentos(nuevosMedicamentos);
  };

  // Función para buscar medicamentos
  const handleBuscarMedicamentos = async () => {
    try {
        const response = await medicGeekApi.get('/medicamentos');
        if (!response || !response.data) throw new Error('Error al obtener medicamentos');

        const data = response.data;
        setMedicamentosSearchResults(data);
        setSearchTermMedic(''); // Limpiar el campo de búsqueda
        setIsMedicamentosModalOpen(true); // Abrir el modal

        // Forzar enfoque en el input aquí, después de abrir el modal
        setTimeout(() => {
            if (searchInputRef.current) {
                searchInputRef.current.focus();
            }
        }, 100); // Un retraso corto
    } catch (error) {
        console.error('Error fetching medicamentos:', error.message);
    }
  };

  // Seleccionar medicamento y cargarlo
  const handleSelectMedicamento = (medicamento) => {
    setDescripcionMedicamento(medicamento.producNc);
    setDosis(medicamento.producDs);

    setIsMedicamentosModalOpen(false);
  };

  // Paginacion
  const renderPageNumbers = () => {
    const pageNumbers = [];
    const ellipsis = "...";

    for (let i = 0; i < pageCountConsult; i++) {
      // Mostrar solo 5 páginas alrededor de la página actual
      if (
        i === 0 ||
        i === pageCountConsult - 1 ||
        (i >= currentPage - 2 && i <= currentPage + 2)
      ) {
        pageNumbers.push(
          <a
            key={i}
            href="!#"
            onClick={() => handlePageChange({ selected: i })}
            className={"page-link"}
          >
            {i + 1}
          </a>
        );
      } else if (i === currentPage - 3 || i === currentPage + 3) {
        // Mostrar (...) antes y después de las páginas ocultas
        pageNumbers.push(
          <span key={i} className={"page-link"}>
            {ellipsis}
          </span>
        );
      }
    }

    return pageNumbers;
  };

  const handleFechaCitaChange = (selectedDates) => {
    if (selectedDates && selectedDates.length > 0) {
      setFechaCita(selectedDates[0]); // Asegúrate de tomar la primera fecha seleccionada
    }
  };

  const handleHoraCitaChange = (e) => {
    setHoraCita(e.target.value);
  };

  const handleNotaCitaChange = (e) => {
    setNotaCita(e.target.value);
  };

  // Altura Receta
  const handleSwitchChange = () => {
    setIsAccordionCitaOpen(!isAccordionCitaOpen);
    setAlturaContenedorCita(!isAccordionCitaOpen ? "auto" : "10rem");
  };

  const handleChangeCantidadPago = (e) => {
    // Obtener el valor introducido en el campo
    let valorIntroducido = e.target.value;

    // Eliminar las comas antes de convertir en número
    valorIntroducido = valorIntroducido.replace(/,/g, "");

    // Verificar si el valor es un número válido
    if (!isNaN(valorIntroducido)) {
      // Aplicar formato de comas para separar los miles
      valorIntroducido = formatoConComas(valorIntroducido);
    } else {
      // Si no es un número válido, establecer el valor predeterminado como 0
      valorIntroducido = "0";
    }

    // Actualizar el estado con el valor formateado
    setCantidadPago(valorIntroducido);
  };
  // Función para aplicar formato de comas para separar los miles
  const formatoConComas = (valor) => {
    if (valor.includes(".")) {
      const partes = valor.split(".");
      partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return partes.join(".");
    } else {
      return valor.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  };

  const handleChangeDescripcionPago = (e) => {
    setDescripcionPago(e.target.value);
  };

  const SaveConsult = async (e) => {
    e.preventDefault();
    try {
      if (paciente && paciente.pcteId) {
        if (!consultMot.trim()) {
          showErrorAlert(
            "Algunos campos son obligatorios. Por favor, complete la información del motivo de la consulta."
          );
          return;
        }

        if (isAccordionCitaOpen) {

          // Verificar si la fecha o la hora no están definidos o son vacíos
          if (!fechaCita || !horaCita) {
            showErrorAlert("Por favor, asegúrese de ingresar tanto la fecha como la hora de la cita.");
            return; // Detiene la ejecución si faltan fecha u hora
          }
        }

        const confirmResult = await showConfirmationAlert(
          "Confirmación",
          "¿Está seguro de que desea guardar la consulta?"
        );

        if (confirmResult.isConfirmed) {
          setCamposCompletos(true);
          setOpenModalSaveConsult(true);
          
         
        }
      } else {
        console.error(
          "No se puede guardar la consulta sin fecha o ID de paciente"
        );
        showErrorAlert(
          "No se puede guardar la consulta sin fecha o ID de paciente"
        );
      }
    } catch (error) {
      console.error("Error al guardar la consulta:", error);
      showErrorAlert("Hubo un error al guardar la consulta");
    }
  };

  // Guardar Consulta
  const saveConsultModal = async (e) => {
   e.preventDefault();

  if (isSavingRef.current) return;

  isSavingRef.current = true;
  setIsSaving(true);

  try {
    let consultId;
    let tappctesId;

    const fechaFormateada = formatearFecha(new Date());
    const horaFormateada = formatearHora(new Date());

    // Guardando la Consulta
    const consultaData = {
      pcteId: paciente.pcteId,
      consultFec: `${fechaFormateada} ${horaFormateada}`,
      estatus: "Completada",
      codeCie10,
      causeId,
      categoryId,
      consultMot,
      consultHea,
      exam1,
      exam2,
      exam3,
      exam4,
      exam5,
      exam6,
      exam7,
      exam8,
      exam9,
      exam10,
      exam11,
      exam12,
      exam13,
      exam14,
      exam15,
      exam16,
      exam17,
      exam18,
      examComentario,
      estGabinete,
      consultDiag,
      consultTipDiag,
      consultClaDiag,
      resultLab,
    };
    // console.log('Datos de la consulta',consultaData)
    // 🔒 VALIDACIÓN ANTI-DUPLICADO (ANTES DE GUARDAR)
try {
  const responseCheck = await medicGeekApi.get(
    `/consults?pcteId=${paciente.pcteId}`
  );

  const consultasExistentes = responseCheck.data || [];

  const yaExiste = consultasExistentes.some((c) => {
    if (!c?.consultFec) return false;

    return c.consultFec === `${fechaFormateada} ${horaFormateada}`;
  });

  if (yaExiste) {
    showErrorAlert("Esta consulta ya fue registrada.");
    return; // ⛔ DETIENE TODO
  }
} catch (error) {
  console.error("Error validando duplicados:", error);
  // ⚠️ puedes decidir si continuar o no
}
    try {
      const responseConsulta = await medicGeekApi.post("/consults", consultaData);
      consultId = responseConsulta.data.consultId;
      if (responseConsulta.status !== 200 && responseConsulta.status !== 201) {
        throw new Error(`Error en consulta, status: ${responseConsulta.status}`);
      }
    } catch (error) {
      console.error("Error al guardar la consulta:", error);
      showErrorAlert("Hubo un error al guardar la consulta");
      return;
    }
    
    // Guardando los datos patologicos
    const antPatologicosData = {
      pcteId: paciente.pcteId,
      consultId: consultId,
    };

    const camposACopiar = [
      "checke1",
      "checke2",
      "checke3",
      "checke4",
      "checke5",
      "checke6",
      "checke7",
      "checke8",
      "checke9",
      "checke10",
      "checke11",
      "checke12",
      "checke13",
      "checke14",
      "checke15",
      "toxicChecke1",
      "toxicChecke2",
      "toxicChecke3",
      "toxicOtros",
      "antOtros",
      "antFarmacos",
      "mquirur",
      "mtrauma",
      "malergi",
      "mtransf",
      "mmadre",
      "mpadre",
      "mconyu",
      "motros",
    ];

    for (const campo of camposACopiar) {
      antPatologicosData[campo] = tappctesData[campo];
    }

    const responseAntPat = await medicGeekApi.post("/tappctes", antPatologicosData);

    // console.log('Los datos de patologia',antPatologicosData)

    if (responseAntPat.status === 400) {
      console.error(
        "Error al guardar/actualizar los antecedentes patológicos:",
        responseAntPat.statusText
      );
      showErrorAlert(
        "Hubo un error al guardar/actualizar los antecedentes patológicos"
      );
      return;
    }
    // Termina de guardar la patologia

    
    // Después de guardar la receta
    if (medicamentos.length > 0) {
      // Lógica para recetas: enviar cada medicamento al endpoint de recetas
      for (const medicamento of medicamentos) {
        // Crear el objeto receta con los datos necesarios
        const recetaData = {
          consultId: consultId, // Asignar el consultId correspondiente a cada receta
          medicNm: medicamento.medicamento || "", // Nombre del medicamento
          medicDosis: medicamento.dosis || "", // Dosis del medicamento
          medicTotal: medicamento.total || "", // Total del medicamento
        };
    
        try {
          // Enviar el objeto receta al endpoint de recetas
          const responseReceta = await medicGeekApi.post("/recetas", recetaData, {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          });
    
          // Comprobar si la respuesta fue exitosa
          if (responseReceta.status === 200 || responseReceta.status === 201) {
            // console.log("Receta guardada exitosamente para el medicamento:", medicamento.medicamento);
          } else {
            console.error("Error al guardar la receta:", responseReceta.statusText);
            showErrorAlert("Hubo un error al guardar la receta");
          }
        } catch (error) {
          console.error("Error al guardar la receta:", error);
          showErrorAlert("Hubo un error al guardar la receta");
        }
      }
    } else {
      // No hay medicamentos, no se ejecutará el código relacionado con recetas
      // console.log("No hay medicamentos para procesar.");
    }
    
    
    // Registrar la cita
    if (isAccordionCitaOpen) {

    // Verificar si la fecha o la hora no están definidos o son vacíos
    if (!fechaCita || !horaCita) {
      showErrorAlert("Por favor, asegúrese de ingresar tanto la fecha como la hora de la cita.");
      return; // Detiene la ejecución si faltan fecha u hora
    }
    
    try {
      let guardarCitaFlag = true; // 🔥 control del flujo

      const fechaNueva = formatearFechaCita(new Date(fechaCita));

      const responseValidacion = await medicGeekApi.get(
        `/calendars?pcteId=${paciente.pcteId}`
      );

      const citasExistentes = responseValidacion.data || [];

     const existeCitaMismaFecha = citasExistentes.some((cita) => {

      if (!cita?.fechaCita) return false;

      if (Number(cita.pcteId) !== Number(paciente.pcteId))
        return false;

      const fechaExistente = cita.fechaCita.split(" ")[0];

      return fechaExistente === fechaNueva;

    });

      // 🔴 SI EXISTE → NO GUARDAR PERO CONTINUAR
      if (existeCitaMismaFecha) {
        showErrorAlert(
          `El paciente ya tiene una cita registrada para el ${fechaNueva}`
        );

        guardarCitaFlag = false; // ⛔ solo bloquea la cita
      }

      // 🟢 SOLO SI SE PERMITE → GUARDAR
      if (guardarCitaFlag) {
        const fechaActual = new Date();
        const fechaCitaReg = formatearFechaHora(fechaActual);

        const nuevaCita = {
          consultId: consultId,
          pcteId: paciente.pcteId,
          categoryId: categoryCitaId || 1,
          fechaCitaReg: fechaCitaReg,
          horaCita: formatearHora12Horas(horaCita),
          fechaCita: `${fechaNueva} ${formatearHora12Horas(horaCita)}`,
          notaCita: notaCita,
          estatus: "Activo",
        };

        const responseCita = await medicGeekApi.post("/calendars", nuevaCita);

        if (
          responseCita.status !== 200 &&
          responseCita.status !== 201
        ) {
          console.error("Error al crear la cita:", responseCita.statusText);
          showErrorAlert("Hubo un error al crear la cita");
          return;
        }
      }

      // ✅ IMPORTANTE: aquí sigue el flujo padre SIEMPRE
      // 👉 nada se rompe ya
     // console.log(citasExistentes[0]);

    } catch (error) {
      console.error("Error al crear/validar la cita:", error);
      showErrorAlert("Hubo un error al crear la cita");
      // ⚠️ aquí sí puedes usar return si quieres frenar todo por error real
    }

    } else {
      // console.log('La opción Swift no está habilitada.');
    }


    // Actualizar el estado de activo a completado en calendario
    if (paciente.estatus || paciente.estatusCalendar === "Activo") {
      const updateStatusData = {
        estatus: "Completada",
      };

      const calendarId = paciente.calendarId;

      if (calendarId) {
        try {
          const responseUpdateStatus = await medicGeekApi.patch(
            `/calendars/${calendarId}`,
            updateStatusData
          );

          if (responseUpdateStatus.status === 200 || responseUpdateStatus.status === 201 ) {
            // console.log('Estado actualizado a "Completada" en el calendario');
            // showSuccessAlert(
            //   'Estado actualizado a "Completada" en el calendario'
            // );
          } else {
            console.error(
              "Error al actualizar el estado en el calendario:",
              responseUpdateStatus.statusText
            );
            showErrorAlert(
              "Hubo un error al actualizar el estado en el calendario"
            );
          }

          // console.log(
          //   "Respuesta de la actualización del estado:",
          //   responseUpdateStatus
          // ); // Agregar este console.log
        } catch (error) {
          console.error(
            "Error al actualizar el estado en el calendario:",
            error
          );
          showErrorAlert(
            "Hubo un error al actualizar el estado en el calendario"
          );
        }
      } else {
        // console.error("No se pudo obtener el calendarId desde paciente");
        showErrorAlert("No se pudo obtener el ID del calendario");
      }
    }

    // Registrar pago
    const pagoData = {
      payCt:
        cantidadPago.trim() !== ""
          ? parseFloat(cantidadPago.replace(/,/g, ""))
          : 0,
      pcteId: paciente.pcteId,
      consultId: consultId,
      payFec: `${fechaFormateada} ${horaFormateada}`,
      payDesc: descripcionPago,
    };

    try {
      const responsePago = await medicGeekApi.post("/pays", pagoData);

      if (responsePago.status === 200 || responsePago.status === 201) {
        
      } else {
        console.error("Error al registrar el pago:", responsePago.statusText);
        showErrorAlert("Hubo un error al registrar el pago");
      }
    } catch (error) {
      console.error("Error al registrar el pago:", error);
      showErrorAlert("Hubo un error al registrar el pago");
    }

    showSuccessAlert("La Consulta fue Guardada Correctamente");
    onCloseForm();
    history("/patients");
  } finally {
    isSavingRef.current = false;
    setIsSaving(false);
  }
  };

  // Guardar los Análisis
  const saveAnalysis = async () => {
    const fechaFormateada = formatearFecha(new Date());
    const horaFormateada = formatearHora(new Date());

    try {
      // Datos de los Análisis
      const analysisData = {
        pcteId: paciente.pcteId,
        // consultId: consultId,
        analysiFec: `${fechaFormateada} ${horaFormateada}`,
      };

      // Nombres de los campos de análisis
      const analysisFields = Array.from(
        { length: 43 },
        (_, i) => `analysis${i + 1}`
      );

      // Generar las propiedades para los campos de análisis
      analysisFields.forEach((fieldName) => {
        analysisData[fieldName] = analysisValues[fieldName];
      });

      // Enviar los análisis al endpoint correcto
      const responseAnalisis = await medicGeekApi.post(
        "/analysis",
        analysisData
      );

      // console.log('Datos del análisis:', analysisData);

      if (responseAnalisis.status === 400) {
        console.error(
          "Error al guardar los análisis:",
          responseAnalisis.statusText
        );
        showErrorAlert("Hubo un error al guardar los análisis");
        return;
      }

      showSuccessAlert("Los Análisis fueron Guardados Correctamente");

      // Objeto con valores iniciales
      const initialAnalysisValues = Object.fromEntries(
        analysisFields.map((fieldName) => [fieldName, ""]) // Puedes inicializar con los valores que desees
      );

      // Reiniciar el estado de analysisValues a su estado inicial
      setAnalysisValues(initialAnalysisValues);

      // Cerrar el modal
      setOpenModalResultadoLab(false);
    } catch (error) {
      console.error("Error al guardar los análisis:", error);
      showErrorAlert("Hubo un error al guardar los análisis");
    }
  };

  const CancelConsult = () => {
    onCloseForm();
    history("/patients");
  };

  const formatearFechaCitaReport = (fecha) => {
    const opciones = { day: "numeric", month: "long", year: "numeric" };
    return new Intl.DateTimeFormat("es-ES", opciones).format(fecha);
  };

  const convertirFechaLarga = (fechaStr, horaStr) => {
    const opcionesFecha = { day: "numeric", month: "long", year: "numeric" };
    const opcionesHora = { hour: "numeric", minute: "numeric", hour12: true };

    if (!fechaStr || !horaStr) {
      return ""; // Retorna una cadena vacía si no hay fecha u hora
    }

    // Si fechaStr es un objeto Date, formatearlo adecuadamente
    if (fechaStr instanceof Date) {
      fechaStr = fechaStr.toISOString().split("T")[0];  // Convertir a 'YYYY-MM-DD'
    }

    const [year, month, day] = fechaStr.split("-");  // Asegúrate de que sea una cadena
    const [hour, minute] = horaStr.split(":");

    // Crear una instancia de Date
    const fecha = new Date(year, month - 1, day, hour, minute);

    // Verificar si la fecha es válida
    if (isNaN(fecha.getTime())) {
      return "Fecha inválida"; // Manejar el error de fecha inválida
    }

    // Formatear la fecha
    const fechaLarga = new Intl.DateTimeFormat("es-ES", opcionesFecha).format(fecha);

    // Formatear la hora en formato AM/PM
    const horaLarga = new Intl.DateTimeFormat("es-ES", opcionesHora).format(fecha);

    const partesFecha = fechaLarga.split(" de ");
    const dia = partesFecha[0];
    const mes = partesFecha[1];
    const año = partesFecha[2];

    return `día ${dia} del mes de ${mes} del año ${año} a las ${horaLarga}`;
  };

  const convertirFechaLargaRecibo = (fecha) => {
    const opciones = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return fecha.toLocaleDateString('es-ES', opciones);
  };

  const fechaStr = "6/6/2024 9:44 AM";
  const fechaCitaLarga = convertirFechaLarga(fechaStr);

  const numeroALetras = (num) => {
    const unidades = ["", "UNO", "DOS", "TRES", "CUATRO", "CINCO", "SEIS", "SIETE", "OCHO", "NUEVE"];
    const especiales = ["DIEZ", "ONCE", "DOCE", "TRECE", "CATORCE", "QUINCE", "DIECISEIS", "DIECISIETE", "DIECIOCHO", "DIECINUEVE"];
    const decenas = ["", "", "VEINTE", "TREINTA", "CUARENTA", "CINCUENTA", "SESENTA", "SETENTA", "OCHENTA", "NOVENTA"];
    const centenas = ["", "CIENTO", "DOSCIENTOS", "TRESCIENTOS", "CUATROCIENTOS", "QUINIENTOS", "SEISCIENTOS", "SETECIENTOS", "OCHOCIENTOS", "NOVECIENTOS"];

    if (num === 0) return "CERO";

    let letras = "";

    // Miles
    if (Math.floor(num / 1000) > 0) {
        if (Math.floor(num / 1000) === 1) {
            letras += "MIL ";
        } else {
            letras += numeroALetras(Math.floor(num / 1000)) + " MIL ";
        }
        num %= 1000;
    }

    // Centenas
    if (Math.floor(num / 100) > 0) {
        letras += centenas[Math.floor(num / 100)] + " ";
        num %= 100;
    }

    // Decenas y unidades especiales (10-19)
    if (num >= 10 && num < 20) {
        letras += especiales[num - 10] + " ";
    } else {
        // Decenas
        if (Math.floor(num / 10) > 1) {
            letras += decenas[Math.floor(num / 10)];
            if (num % 10 > 0) letras += " Y ";
        }

        // Unidades
        letras += unidades[num % 10] + " ";
    }

    return letras.trim();
  };

  const convertirFacturaCtALetras = (valor) => {
    // Eliminar comas antes de convertir en número
    valor = valor.replace(/,/g, "");

    if (valor === undefined || isNaN(valor)) return "CERO PESOS";

    const [parteEntera, decimales] = parseFloat(valor).toFixed(2).split(".");
    const cantidadEnLetras = numeroALetras(parseInt(parteEntera, 10));
    const centavosEnLetras = decimales === "00" ? "" : `CON ${numeroALetras(parseInt(decimales, 10))} CENTAVOS`;

    return `${cantidadEnLetras} PESOS ${centavosEnLetras}`.trim();
  };

  // Imprimir receta
  const previsualizarPDF = () => {
      const doc = new jsPDF();
      
      // Registrar la fuente
      doc.addFileToVFS("Calibri.ttf", CalibriNormal);
      doc.addFont("Calibri.ttf", "Calibri", "normal");
      doc.setFont("Calibri", "normal");
      // Configurar la página
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const margin = 10;
      const lineHeight = 5;
      let y = margin; // Posición inicial Y
      const paddingSuperior = 30;
      const medicamentosMaxHeight = 110;

      const fechaFormateada = formatearFechaCitaReport(new Date());

      let fechaCitaLarga = "";
      if (isAccordionCitaOpen && fechaCita && horaCita) {
          fechaCitaLarga = convertirFechaLarga(fechaCita, horaCita);
      }

      if (!medicamentos || medicamentos.length === 0) {
          showErrorAlert("No hay datos de receta seleccionada");
          return;
      }

      const agregarDatosPaciente = () => {
        y += paddingSuperior;
        doc.setFontSize(14);

        const margin = 8;
        const resultadoMargin = 30;
        const lineHeight = 5;

        const nombreCompleto = `${paciente.pcteNom || ""} ${paciente.pcteNom2 || ""} ${paciente.pcteApe1 || ""} ${paciente.pcteApe2 || ""}`.trim();
        const cedulaTexto = paciente.pcteNumDoc || "No disponible";

        doc.text(`Paciente:`, margin, y);
        doc.text(nombreCompleto, resultadoMargin, y);
        y += lineHeight;

        doc.text(`Cédula:`, margin, y);
        doc.text(cedulaTexto, resultadoMargin, y);
        y += lineHeight;

        doc.text(`Fecha:`, margin, y);
        doc.text(fechaFormateada, resultadoMargin, y);
        y += lineHeight;
      };

      const agregarTextoRX = (xPos, yPos) => {
        doc.setFontSize(16); // Tamaño adecuado para "RX"
        doc.text("R", xPos, yPos);
        doc.setFontSize(12); // Reducir tamaño para "X" si es necesario
        doc.text("X", xPos + 2, yPos + 1.9); // Ajustar posiciones para sobreponer la "X"
        doc.setFont("Calibri", "bold");
      };

      const agregarCita = () => {
        const y = pageHeight - 150;
    
        // Establecer la fuente a normal para "Cita:"
        doc.setFont("Calibri", "bold");
        doc.text(`Cita: `, margin, y);
    
        // Establecer la fuente a negrita para fechaCitaLarga
        doc.setFont("Calibri", "bold");
        doc.text(fechaCitaLarga ? fechaCitaLarga : "No hay próxima cita asignada", margin + doc.getTextWidth("Cita: "), y);
    
        // Restablecer la fuente a normal si es necesario
        doc.setFont("Calibri", "normal");
      };

      const agregarFirmaDoctor = () => {
        y = pageHeight - 150;
        const firmaMarginLeft = pageWidth / 2 - -45;
        doc.line(firmaMarginLeft, y, firmaMarginLeft + 60, y);
        y += lineHeight;

        const doctorName = profileData.docNom;
        const doctorNameWidth = doc.getTextWidth(doctorName);
        const nameMarginRight = 75;
        doc.text(doctorName, (pageWidth - doctorNameWidth) / 2 + nameMarginRight, y);
        y += lineHeight;

        const doctorExe = `${profileData.docExe}`;
        const doctorExeWidth = doc.getTextWidth(doctorExe);
        doc.setFontSize(10);
        doc.text(doctorExe, (pageWidth - doctorExeWidth) / 2 + nameMarginRight, y);
      };

      const agregarMedicamentos = () => {
          let totalHeight = 0;
          y += lineHeight + 8;

          medicamentos.forEach((medicamento, index) => {
              const medicamentoTexto = `${index + 1} - ${medicamento.medicamento}`;
              const dosisTexto = medicamento.dosis.toUpperCase();

              const alturaMedicamento = lineHeight;
              const alturaDosis = lineHeight + 5;

              totalHeight += alturaMedicamento + alturaDosis;
              if (totalHeight > medicamentosMaxHeight) {
                  agregarCita();
                  agregarFirmaDoctor();
                  doc.addPage();
                  y = margin;
                  agregarDatosPaciente();
                  totalHeight = alturaMedicamento + alturaDosis;
              }

              
              doc.addFileToVFS("Calibri.ttf", CalibriBold);
              doc.addFont("Calibri.ttf", "Calibri", "bold");
              doc.setFont("Calibri", "bold");
              doc.text(medicamentoTexto, margin, y);
              y += alturaMedicamento;

              doc.setFontSize(10);
              doc.setFont("Calibri", "normal");
              doc.text(dosisTexto, margin, y);
              y += alturaDosis - 4;
              doc.setFontSize(12);
          });
      };
    

      agregarDatosPaciente();
      agregarTextoRX(margin, y + 2); // Posiciona el texto RX por encima de los medicamentos
      agregarMedicamentos();
      agregarCita();
      agregarFirmaDoctor();

      // Convertir el PDF a Blob
      const pdfBlob = doc.output('blob');

      // Crear un iframe oculto en el DOM
      let iframe = document.createElement('iframe');
      iframe.style.display = 'none';  // Mantener el iframe oculto
      document.body.appendChild(iframe);

      // Crear una URL para el blob del PDF
      const blobUrl = URL.createObjectURL(pdfBlob);

      // Cargar el PDF en el iframe
      iframe.src = blobUrl;

      // Ejecutar el diálogo de impresión cuando el PDF se haya cargado
     iframe.onload = () => {
      setTimeout(() => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();

        iframe.contentWindow.onafterprint = () => {
          document.body.removeChild(iframe);
          URL.revokeObjectURL(blobUrl);
        };
      }, 500); // 500 ms, puedes ajustar si hace falta
    };

  };

  
 // =====================================================
// DETECTAR SI EL CONTENIDO ES HTML
// =====================================================

const isHtmlContent = (value = "") => {
  if (!value || typeof value !== "string") {
    return false;
  }

  return /<\/?[a-z][\s\S]*>/i.test(value);
};


// =====================================================
// IMPRIMIR TEXTO PLANO
// Compatible con registros antiguos
// =====================================================

const renderPlainTextRecetaPDF = (
  doc,
  text = "",
  startY,
  pageWidth,
  pageHeight,
  margin = 15
) => {

  let y = startY;

  const lineHeight = 6;

  doc.setFont("Calibri", "normal");
  doc.setFontSize(12);

  const paragraphs = String(text || "")
    .split(/\r?\n/);

  paragraphs.forEach((paragraph) => {

    // Línea vacía
    if (!paragraph.trim()) {
      y += lineHeight;
      return;
    }

    const lines = doc.splitTextToSize(
      paragraph,
      pageWidth - margin * 2
    );

    lines.forEach((line) => {

      // Nueva página
      if (y + lineHeight > pageHeight - 20) {

        doc.addPage();

        y = 25;

        doc.setFont("Calibri", "normal");
        doc.setFontSize(12);
      }

      doc.text(
        line,
        margin,
        y
      );

      y += lineHeight;
    });

  });

  return y;
};


// =====================================================
// IMPRIMIR HTML / RICH TEXT
// Compatible con ProRichTextEditor
// =====================================================

const renderRichTextRecetaPDF = (
  doc,
  html = "",
  startY,
  pageWidth,
  pageHeight,
  margin = 15
) => {

  const parser = new DOMParser();

  const htmlDoc = parser.parseFromString(
    html || "",
    "text/html"
  );

  let y = startY;

  const fontSize = 12;
  const lineHeight = 7;

  const maxWidth =
    pageWidth - margin * 2;


  // =====================================================
  // VALIDAR SALTO DE PAGINA
  // =====================================================

  const checkPage = () => {

    if (y + lineHeight > pageHeight - 20) {

      doc.addPage();

      y = 25;

      doc.setFont("Calibri", "normal");
      doc.setFontSize(fontSize);
    }

  };


  // =====================================================
  // RENDER INLINE
  // Negrita / cursiva / subrayado
  // =====================================================

  const renderInline = (
    node,
    x,
    currentY,
    styles = {}
  ) => {

    // TEXTO
    if (node.nodeType === Node.TEXT_NODE) {

      const text =
        node.textContent || "";

      if (!text) {
        return x;
      }


      // Actualmente tienes solamente
      // Calibri normal registrada.
      //
      // Para evitar errores usamos Helvetica
      // para bold/italic y Calibri para normal.

      if (styles.bold && styles.italic) {

        doc.setFont(
          "helvetica",
          "bolditalic"
        );

      } else if (styles.bold) {

        doc.setFont(
          "helvetica",
          "bold"
        );

      } else if (styles.italic) {

        doc.setFont(
          "helvetica",
          "italic"
        );

      } else {

        doc.setFont(
          "Calibri",
          "normal"
        );
      }


      doc.setFontSize(fontSize);


      const words =
        text.split(/(\s+)/);


      words.forEach((word) => {

        if (!word) {
          return;
        }


        const wordWidth =
          doc.getTextWidth(word);


        // Salto de línea
        if (
          x + wordWidth >
          pageWidth - margin
        ) {

          y += lineHeight;

          checkPage();

          currentY = y;

          x = margin;
        }


        doc.text(
          word,
          x,
          currentY
        );


        // SUBRAYADO
        if (
          styles.underline &&
          word.trim()
        ) {

          doc.setLineWidth(0.2);

          doc.line(
            x,
            currentY + 1,
            x + wordWidth,
            currentY + 1
          );
        }


        x += wordWidth;

      });


      return x;
    }


    // SI NO ES ELEMENTO
    if (
      node.nodeType !==
      Node.ELEMENT_NODE
    ) {

      return x;
    }


    const tag =
      node.tagName.toLowerCase();


    const childStyles = {

      ...styles,

      bold:
        styles.bold ||
        tag === "strong" ||
        tag === "b",

      italic:
        styles.italic ||
        tag === "em" ||
        tag === "i",

      underline:
        styles.underline ||
        tag === "u",

    };


    node.childNodes.forEach((child) => {

      x = renderInline(
        child,
        x,
        currentY,
        childStyles
      );

    });


    return x;
  };


  // =====================================================
  // PARRAFOS
  // =====================================================

  const renderParagraph = (element) => {

    checkPage();


    const align =
      element.style.textAlign ||
      "left";


    const text =
      element.textContent?.trim() ||
      "";


    // Párrafo vacío
    if (!text) {

      y += lineHeight;

      return;
    }


    // =====================================================
    // CENTRADO / DERECHA
    // =====================================================

    if (
      align === "center" ||
      align === "right"
    ) {

      doc.setFont(
        "Calibri",
        "normal"
      );

      doc.setFontSize(fontSize);


      const lines =
        doc.splitTextToSize(
          text,
          maxWidth
        );


      lines.forEach((line) => {

        checkPage();


        if (align === "center") {

          doc.text(
            line,
            pageWidth / 2,
            y,
            {
              align: "center",
            }
          );

        } else {

          doc.text(
            line,
            pageWidth - margin,
            y,
            {
              align: "right",
            }
          );

        }


        y += lineHeight;

      });

    }

    // =====================================================
    // IZQUIERDA
    // =====================================================

    else {

      renderInline(
        element,
        margin,
        y
      );

      y += lineHeight;

    }


    y += 2;
  };


  // =====================================================
  // LISTAS
  // =====================================================

  const renderList = (
    element,
    level = 0
  ) => {

    const tag =
      element.tagName.toLowerCase();


    const items =
      Array.from(element.children)
        .filter(
          (child) =>
            child.tagName
              .toLowerCase() === "li"
        );


    items.forEach((li, index) => {

      checkPage();


      const indent =
        margin + level * 8;


      const bullet =
        tag === "ol"
          ? `${index + 1}.`
          : "•";


      doc.setFont(
        "Calibri",
        "normal"
      );

      doc.setFontSize(fontSize);


      doc.text(
        bullet,
        indent,
        y
      );


      const textStart =
        indent + 6;


      // Evitar que listas internas
      // se impriman dos veces

      const directNodes =
        Array.from(li.childNodes)
          .filter((node) => {

            if (
              node.nodeType ===
                Node.ELEMENT_NODE &&
              ["UL", "OL"].includes(
                node.tagName
              )
            ) {

              return false;
            }

            return true;
          });


      let x = textStart;


      directNodes.forEach((node) => {

        x = renderInline(
          node,
          x,
          y
        );

      });


      y += lineHeight;


      // LISTAS ANIDADAS

      Array.from(li.children)
        .filter((child) =>
          ["UL", "OL"].includes(
            child.tagName
          )
        )
        .forEach((nestedList) => {

          renderList(
            nestedList,
            level + 1
          );

        });

    });


    y += 2;
  };


  // =====================================================
  // BLOQUES HTML
  // =====================================================

  const renderBlock = (
    element,
    level = 0
  ) => {

    const tag =
      element.tagName
        ?.toLowerCase();


    if (!tag) {
      return;
    }


    if (tag === "p") {

      renderParagraph(element);

    }

    else if (
      tag === "ul" ||
      tag === "ol"
    ) {

      renderList(
        element,
        level
      );

    }

    else {

      Array.from(
        element.children
      ).forEach((child) => {

        renderBlock(
          child,
          level
        );

      });

    }

  };


  // =====================================================
  // PROCESAR DOCUMENTO
  // =====================================================

  Array.from(
    htmlDoc.body.children
  ).forEach((element) => {

    renderBlock(element);

  });


  return y;
};


// =====================================================
// RENDER UNIVERSAL
// TEXTO ANTIGUO + HTML NUEVO
// =====================================================

const renderRecetaContent = (
  doc,
  content,
  startY,
  pageWidth,
  pageHeight,
  margin = 15
) => {

  if (!content) {

    return renderPlainTextRecetaPDF(
      doc,
      "No hay información de referimiento disponible.",
      startY,
      pageWidth,
      pageHeight,
      margin
    );

  }


  // NUEVO FORMATO
  if (isHtmlContent(content)) {

    return renderRichTextRecetaPDF(
      doc,
      content,
      startY,
      pageWidth,
      pageHeight,
      margin
    );

  }


  // FORMATO ANTIGUO
  return renderPlainTextRecetaPDF(
    doc,
    content,
    startY,
    pageWidth,
    pageHeight,
    margin
  );

};


// =====================================================
// PREVISUALIZAR / IMPRIMIR REFERIMIENTO
// =====================================================

const previsualizarPDFRecetaControlada = () => {

  const doc = new jsPDF();


  // =====================================================
  // FUENTE
  // =====================================================

  doc.addFileToVFS(
    "Calibri.ttf",
    CalibriNormal
  );

  doc.addFont(
    "Calibri.ttf",
    "Calibri",
    "normal"
  );

  doc.setFont(
    "Calibri",
    "normal"
  );


  // =====================================================
  // CONFIGURACION PAGINA
  // =====================================================

  const pageWidth =
    doc.internal.pageSize.getWidth();

  const pageHeight =
    doc.internal.pageSize.getHeight();


  const margin = 15;

  const paddingSuperior = 30;

  let y = margin;


  const fechaFormateada =
    formatearFechaCitaReport(
      new Date()
    );


  // =====================================================
  // DATOS PACIENTE
  // =====================================================

  const agregarDatosPaciente = () => {

    y += paddingSuperior;


    doc.setFont(
      "Calibri",
      "normal"
    );

    doc.setFontSize(12);


    // PACIENTE

    doc.text(
      "Paciente:",
      margin,
      y
    );


    const nombreCompleto = [
      paciente?.pcteNom,
      paciente?.pcteNom2,
      paciente?.pcteApe1,
      paciente?.pcteApe2,
    ]
      .filter(Boolean)
      .join(" ")
      .trim();


    doc.text(
      nombreCompleto,
      margin + 30,
      y
    );


    y += 6;


    // CEDULA

    doc.text(
      "Cédula:",
      margin,
      y
    );


    doc.text(
      String(
        paciente?.pcteNumDoc ||
        ""
      ),
      margin + 30,
      y
    );


    y += 6;


    // FECHA

    doc.text(
      "Fecha:",
      margin,
      y
    );


    doc.text(
      fechaFormateada,
      margin + 30,
      y
    );


    y += 6;
  };


  // =====================================================
  // TITULO REFERIMIENTO
  // =====================================================

  const agregarTitulo = () => {

    y += 12;


    doc.setFont(
      "helvetica",
      "bold"
    );

    doc.setFontSize(14);

    y += 10;


    doc.setFont(
      "Calibri",
      "normal"
    );

    doc.setFontSize(12);
  };


  // =====================================================
  // CONTENIDO
  // =====================================================

  agregarDatosPaciente();

  agregarTitulo();


  y = renderRecetaContent(
    doc,
    recetaControlada,
    y,
    pageWidth,
    pageHeight,
    margin
  );


  // =====================================================
  // PDF A BLOB
  // =====================================================

  const pdfBlob =
    doc.output("blob");


  const blobUrl =
    URL.createObjectURL(
      pdfBlob
    );


  // =====================================================
  // IFRAME IMPRESION
  // =====================================================

  const iframe =
    document.createElement(
      "iframe"
    );


  iframe.style.display =
    "none";


  document.body.appendChild(
    iframe
  );


  iframe.src =
    blobUrl;


  iframe.onload = () => {

    iframe.contentWindow.focus();

    iframe.contentWindow.print();


    iframe.contentWindow.onafterprint =
      () => {

        document.body.removeChild(
          iframe
        );

        URL.revokeObjectURL(
          blobUrl
        );

      };

  };

};

  const previsualizarReciboPDF = async (factura) => {
    const doc = new jsPDF();
    
    // Registrar la fuente
      doc.addFileToVFS("Calibri.ttf", CalibriNormal);
      doc.addFont("Calibri.ttf", "Calibri", "normal");
      doc.setFont("Calibri", "normal");
      // Configurar la página

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 10;
    const additionalMargin = 40;
    const fontSize = 10;

    const fechaFormateada = convertirFechaLargaRecibo(new Date());

    doc.setFontSize(fontSize);

    const fechaLarga = new Date().toLocaleDateString();
    const cantidadEnLetras = convertirFacturaCtALetras(cantidadPago);
    const nombreCompleto = paciente
        ? `${paciente.pcteNom || ""} ${paciente.pcteNom2 || ""} ${paciente.pcteApe1 || ""} ${paciente.pcteApe2 || ""}`
        : "OTROS INGRESOS";

    // Título
    doc.setFontSize(22);
    doc.addFileToVFS("Calibri.ttf", CalibriBold);
    doc.addFont("Calibri.ttf", "Calibri", "bold");
    doc.setFont("Calibri", "bold");
    const detalleText = "RECIBO DE PAGO";
    const textWidth = doc.getTextWidth(detalleText);
    const centeredX = (pageWidth - textWidth) / 2;
    doc.text(detalleText, centeredX, margin + additionalMargin);
    doc.setFont("Calibri", "normal");

    // Información del paciente y recibo
    doc.setFontSize(12);
    const profileText = `Recibimos en el día de hoy de parte de ${nombreCompleto},. Cédula de identidad número ${paciente?.pcteNumDoc || ""}, la suma de RD$${cantidadPago}.00 (${cantidadEnLetras}), por concepto de consulta realizada en el día de hoy ${fechaFormateada}.`;

    const profileLines = doc.splitTextToSize(profileText, pageWidth - 2 * margin);
    let y = margin + additionalMargin + 20;
    const lineHeight = fontSize * 0.6;

    profileLines.forEach((line) => {
        if (y + lineHeight > pageHeight - margin - additionalMargin - lineHeight) {
            doc.addPage();
            y = margin + additionalMargin;
        }
        doc.text(line, margin, y);
        y += lineHeight;
    });

    // Nombre y exequátur del doctor
    const alturaNombre = y + 50;
    const lineaY = alturaNombre - 5;
    const lineaX = (pageWidth - 80) / 2;
    doc.setLineWidth(0.5);
    doc.line(lineaX, lineaY, lineaX + 80, lineaY);

    const nombreDoctor = profileData.docNom || "Doctor";
    doc.setFontSize(12);
    const nombreX = (pageWidth - doc.getTextWidth(nombreDoctor)) / 1.41;
    doc.text(nombreDoctor, nombreX, alturaNombre, { align: "center" });

    const exequaturText = `Exequátur: ${profileData.docExe || "N/A"}`;
    doc.text(exequaturText, nombreX, alturaNombre + 5, { align: "center" });

    // Convertir el PDF a Blob y generar la vista previa/imprimir
    const pdfBlob = doc.output('blob');
    let iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    document.body.appendChild(iframe);

    const blobUrl = URL.createObjectURL(pdfBlob);
    iframe.src = blobUrl;

    iframe.onload = () => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        iframe.contentWindow.onafterprint = () => {
            document.body.removeChild(iframe);
            URL.revokeObjectURL(blobUrl);
        };
    };
  };

  const calculateIMC = () => {
    if (exam5 && exam6) {
      const pesoKg = parseFloat(exam6) * 0.45359237; // Convertir peso a kilogramos
      const alturaM = parseFloat(exam5) / 100; // Convertir altura a metros
      return (pesoKg / (alturaM * alturaM)).toFixed(0); // Calcular IMC y redondear a 2 decimales
    }
    return "";
  };

  const exam7 = calculateIMC();

  const getAge = (birthDate) => {
    const today = new Date();
    const birth = new Date(birthDate);
    let age = today.getFullYear() - birth.getFullYear();
    const monthDifference = today.getMonth() - birth.getMonth();
  
    // Si el mes actual es anterior al mes de nacimiento o si es el mismo mes pero el día actual es anterior al día de nacimiento
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birth.getDate())) {
      age--;
    }
  
    return age;
  };

  const age = getAge(paciente.pcteEd);

  const formatearFechaNac = (fecha) => {
  if (!fecha) return "";
  const [year, month, day] = fecha.split("-");
  return `${day}-${month}-${year}`;
  };
  // Modal
  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const handleViewDetail = (consult) => {
    setSelectedConsulta(consult);
    setModalOpen(true);
  };

  const toggleModalCertificado = () => {
    setModalCertificadoOpen(!modalCertificadoOpen);
  };

  const handleViewCertificado = (certificado) => {
    setSelectedCertificado(certificado);
    setModalCertificadoOpen(true);
  };
  // Imprimir receta
  const revisualizarPDF = () => {
    const doc = new jsPDF();

    // Registrar la fuente
    doc.addFileToVFS("Calibri.ttf", CalibriNormal);
    doc.addFont("Calibri.ttf", "Calibri", "normal");
    doc.setFont("Calibri", "normal");

    // Configurar la página
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 10;
    const lineHeight = 5;
    let y = margin; // Posición inicial Y
    const paddingSuperior = 30;
    const medicamentosMaxHeight = 110;

    const fechaFormateada =
  recetaActiva?.fechaConsulta || "Fecha no disponible";


    const agregarDatosPaciente = () => {
        y += paddingSuperior; // Agregar padding antes de los datos del paciente
        doc.setFontSize(10);
        
        const margin = 8;
        const resultadoMargin = 30;
        const lineHeight = 5;

        doc.text(`Paciente:`, margin, y);
        const nombreCompleto = `${paciente.pcteNom || ""} ${paciente.pcteNom2 || ""} ${paciente.pcteApe1 || ""} ${paciente.pcteApe2 || ""}`.trim();
        doc.text(nombreCompleto, resultadoMargin, y);
        y += lineHeight;

        doc.text(`Cédula:`, margin, y);
        const cedulaTexto = `${paciente.pcteNumDoc}`;
        doc.text(cedulaTexto, resultadoMargin, y);
        y += lineHeight;

        doc.text(`Fecha:`, margin, y);
        doc.text(fechaFormateada, resultadoMargin, y);
        y += lineHeight;
    };

    const agregarTextoRX = (xPos, yPos) => {
      doc.setFontSize(16); // Tamaño adecuado para "RX"
      doc.text("R", xPos, yPos);
      doc.setFontSize(12); // Reducir tamaño para "X" si es necesario
      doc.text("X", xPos + 2, yPos + 1.9); // Ajustar posiciones para sobreponer la "X"
      doc.setFont("Calibri", "bold");
    };

    const agregarCita = () => {
      const y = pageHeight - 150;
  
      // Establecer la fuente a normal para "Cita:"
      doc.setFont("Calibri", "normal");
      doc.text(`Cita: `, margin, y);
  
      // Establecer la fuente a negrita para fechaCitaLarga
      doc.setFont("Calibri", "bold");
      // doc.text(fechaCitaLarga ? fechaCitaLarga : "No hay próxima cita asignada", margin + doc.getTextWidth("Cita: "), y);
  
      // Restablecer la fuente a normal si es necesario
      doc.setFont("Calibri", "normal");
  };

    const agregarFirmaDoctor = () => {
      y = pageHeight - 150;
      const firmaMarginLeft = pageWidth / 2 - -45;
      doc.line(firmaMarginLeft, y, firmaMarginLeft + 60, y);
      y += lineHeight;

      const doctorName = profileData.docNom;
      const doctorNameWidth = doc.getTextWidth(doctorName);
      const nameMarginRight = 75;
      doc.text(doctorName, (pageWidth - doctorNameWidth) / 2 + nameMarginRight, y);
      y += lineHeight;

      const doctorExe = `${profileData.docExe}`;
      const doctorExeWidth = doc.getTextWidth(doctorExe);
      doc.setFontSize(10);
      doc.text(doctorExe, (pageWidth - doctorExeWidth) / 2 + nameMarginRight, y);
    };

    const agregarMedicamentos = () => {
      let totalHeight = 0;
      y += lineHeight + 8;

      if (!Array.isArray(recetaActiva?.recetas)) return;

      recetaActiva.recetas.forEach((medicamento, index) => {
        const medicamentoTexto = `${index + 1} - ${medicamento.medicNm}`;
        const dosisTexto = medicamento.medicDosis?.toUpperCase() || "";

        const alturaMedicamento = lineHeight;
        const alturaDosis = lineHeight + 5;

        totalHeight += alturaMedicamento + alturaDosis;

        if (totalHeight > medicamentosMaxHeight) {
          agregarCita();
          agregarFirmaDoctor();
          doc.addPage();
          y = margin;
          agregarDatosPaciente();
          totalHeight = alturaMedicamento + alturaDosis;
        }

        doc.setFont("Calibri", "bold");
        doc.text(medicamentoTexto, margin, y);
        y += alturaMedicamento;

        doc.setFontSize(10);
        doc.setFont("Calibri", "normal");
        doc.text(dosisTexto, margin, y);
        y += alturaDosis - 4;
        doc.setFontSize(12);
      });
    };

    agregarDatosPaciente();
    agregarTextoRX(margin, y + 2); // Posiciona el texto RX por encima de los medicamentos
    agregarMedicamentos();
    agregarCita();
    agregarFirmaDoctor();

      // Convertir el PDF a Blob
    const pdfBlob = doc.output('blob');

    // Crear un iframe oculto en el DOM
    let iframe = document.createElement('iframe');
    iframe.style.display = 'none';  // Mantener el iframe oculto
    document.body.appendChild(iframe);

    // Crear una URL para el blob del PDF
    const blobUrl = URL.createObjectURL(pdfBlob);

    // Cargar el PDF en el iframe
    iframe.src = blobUrl;

    // Ejecutar el diálogo de impresión cuando el PDF se haya cargado
      iframe.onload = () => {
      setTimeout(() => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();

        iframe.contentWindow.onafterprint = () => {
          document.body.removeChild(iframe);
          URL.revokeObjectURL(blobUrl);
        };
      }, 500); // 500 ms, puedes ajustar si hace falta
    };
  };
  // Modal para el detalle de las recetas
  const handleCloseRecetaModal = () => {
    setSelectedReceta(null);
    setModalRecetaOpen(false);
  };

  const convertirFechaActualLarga = () => {
    const fecha = new Date();

    const opcionesFecha = { day: "numeric", month: "long", year: "numeric" };
    const opcionesHora = { hour: "numeric", minute: "numeric", hour12: true };

    const fechaLarga = new Intl.DateTimeFormat("es-ES", opcionesFecha).format(fecha);
    const horaLarga = new Intl.DateTimeFormat("es-ES", opcionesHora).format(fecha);

    const partesFecha = fechaLarga.split(" de ");

    const dia = partesFecha[0];
    const mes = partesFecha[1];
    const año = partesFecha[2];

    return `día ${dia} del mes de ${mes} del año ${año} a las ${horaLarga}`;
  };

  const previsualizarPDFCertificados = async () => {

    if (!selectedCertificado) return;

    const doc = new jsPDF();

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const margin = 15;
    const fontSize = 11;

    let y = 30;

    doc.setFontSize(22);
    doc.setFont(undefined, "bold");

    const titulo = "CERTIFICADO MÉDICO";
    const textWidth = doc.getTextWidth(titulo);
    const centeredX = (pageWidth - textWidth) / 2;

    doc.text(titulo, centeredX, y);

    doc.setFont(undefined, "normal");
    doc.setFontSize(fontSize);

    y += 20;

    const fechaLarga = convertirFechaActualLarga();

    const pacienteNombre = `
    ${paciente.pcteNom || ""}
    ${paciente.pcteNom2 || ""}
    ${paciente.pcteApe1 || ""}
    ${paciente.pcteApe2 || ""}
    `.replace(/\s+/g, " ").trim();

    const textoDoctor = `Yo, ${profileData.docNom}, Médico ${profileData.docEsp},
  Cédula de identidad número ${profileData.docCed}, provisto del correspondiente
  exequátur No. ${profileData.docExe}, certifico haber examinado al paciente
  ${pacienteNombre}, Cédula de identidad número ${paciente.pcteNumDoc}.`;

    const doctorLines = doc.splitTextToSize(textoDoctor, pageWidth - margin * 2);

    doctorLines.forEach((line) => {
      doc.text(line, margin, y);
      y += 7;
    });

    y += 10;

    const certificar = `Certifico:\n${selectedCertificado.constatado}`;

    const recomendar = `\n\nPor lo que recomiendo:\n${selectedCertificado.recomedacion}`;

    const contenido = certificar + recomendar;

    const contenidoLines = doc.splitTextToSize(contenido, pageWidth - margin * 2);

    contenidoLines.forEach((line) => {

      if (y > pageHeight - 40) {
        doc.addPage();
        y = 30;
      }

      doc.text(line, margin, y);
      y += 7;
    });

    y += 15;

    const footer = `${profileData.docDirCert} a petición del interesado, hoy ${fechaLarga}`;

    const footerLines = doc.splitTextToSize(footer, pageWidth - margin * 2);

    footerLines.forEach((line) => {
      doc.text(line, margin, y);
      y += 7;
    });

    y += 40;

    const lineWidth = 80;
    const lineX = (pageWidth - lineWidth) / 2;

    doc.line(lineX, y, lineX + lineWidth, y);

    y += 8;

    doc.setFontSize(12);

    doc.text(profileData.docNom, pageWidth / 2, y, { align: "center" });

    y += 6;

    doc.text(`Exequátur: ${profileData.docExe}`, pageWidth / 2, y, {
      align: "center",
    });

    doc.autoPrint();

    const blob = doc.output("blob");

    const url = URL.createObjectURL(blob);

    window.open(url);
  };

  const getPlainText = (html = "") => {
    if (!html) return "";

    const div = document.createElement("div");
    div.innerHTML = html;

    return (div.textContent || div.innerText || "")
      .replace(/\s+/g, " ")
      .trim();
  };

  const truncatePlainText = (html = "", maxLength = 45) => {
    const text = getPlainText(html);

    return text.length > maxLength
      ? `${text.slice(0, maxLength)}...`
      : text;
  };
  const getPlainTextLength = (html = "") => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return (div.textContent || div.innerText || "").length;
  };

  // Guardar formato de TipTap (mayusculas, cursivas, etc.)
  const RichTextDisplay = ({ content }) => {
    if (!content) {
      return (
        <span className="text-muted">
          Sin información
        </span>
      );
    }

    return (
      <div
        className="rich-text-display"
        dangerouslySetInnerHTML={{
          __html: content,
        }}
      />
    );
  };

  return (
    <div className="consulta-form">
       {/* Mostrar pantalla de carga si isLoading es true */}
       {isLoading && (
        <div className="pro-loading-overlay">
          <div className="pro-loading-card">
            {/* LOGO / ICON */}
            <div className="pro-loading-icon">
              <i className="bi bi-heart-pulse-fill"></i>
            </div>
            {/* SPINNER */}
            <div className="pro-loading-spinner"></div>
            {/* TEXT */}
            <h5 className="pro-loading-title">
              Cargando Información
            </h5>
            <p className="pro-loading-subtitle">
              Espere un momento mientras procesamos los datos...
            </p>
          </div>
        </div>
      )}
       {/* El contenido principal de la página */}
      {!isLoading && (
      <div className="sticky-top pt-3 pb-3 px-3 pro-patient-header">
        {/* TOP PROFILE */}
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">

          {/* LEFT */}

          <div className="d-flex align-items-center gap-3 flex-grow-1">

            {/* AVATAR */}

            <div className="pro-patient-header-avatar">

              <img
                alt="Paciente"
                src="https://www.shareicon.net/data/128x128/2016/08/05/806962_user_512x512.png"
                className="pro-patient-header-image"
              />

            </div>

            {/* INFO */}

            <div className="d-flex flex-column">

              <label
                className="pro-patient-header-name"
                id="pcteNom"
              >

                {paciente.pcteNom}{" "}
                {paciente.pcteNom2}{" "}
                {paciente.pcteApe1}{" "}
                {paciente.pcteApe2}

              </label>

              {/* META */}

              <div className="d-flex flex-wrap align-items-center gap-2 mt-2">

                <span className="pro-patient-meta-badge">

                  <i className="bi bi-calendar2-heart"></i>

                  {formatearFechaNac(paciente.pcteEd)}

                </span>

                <span className="pro-patient-meta-divider"></span>

                <span className="pro-patient-meta-badge">

                  <i className="bi bi-person"></i>

                  {age} años

                </span>

                <span className="pro-patient-meta-divider"></span>

                <span className="pro-patient-meta-badge">

                  <i className="bi bi-credit-card-2-front"></i>

                  {paciente.pcteNumDoc}

                </span>

                <span className="pro-patient-meta-divider"></span>

                <span className="pro-patient-meta-badge">

                  <i className="bi bi-gender-ambiguous"></i>

                  {paciente.pcteSx}

                </span>

              </div>

            </div>

          </div>

          {/* RIGHT ACTION */}

          <div className="d-flex justify-content-end">

            <button
              className="pro-btn-primary"
              placeholder="Historico"
              onClick={toggleHistorico}
            >

              {historicoVisible ? (
                <>
                  <i className="bi bi-x-lg"></i>
                  Resumen clínico
                </>
              ) : (
                <>
                  <i className="bi bi-arrow-bar-left"></i>
                  Resumen clínico
                </>
              )}

            </button>

          </div>

        </div>

      </div>
        )}
      <div className="px-3 pb-5 pt-2 d-flex">
        {/* Consulta */}
        <div
          className="mx-2"
          style={{
            width: "100%",
          }}
        >
          <Row>
            <Form
              d-flex
              justify-content-end
              onSubmit={SaveConsult}
              className="bg-white pt-2 rounded-2"
            >
              {/* Informacion del paciente */}
              <div
                className={`pro-patient-summary-wrapper mb-5 ${
                  expanded ? "pro-expanded" : ""
                }`}
              >
                <div
                  className={`pro-patient-summary-card ${
                    expanded ? "transicionWipeButton" : ""
                  }`}
                >
                  <div className="row g-4">

                    {/* =========================================================
                        LEFT COLUMN
                      ========================================================= */}

                    <div className="col-12 col-xl-6">

                      <Form>

                        {/* =========================================
                            ANTECEDENTES
                          ========================================= */}

                        <div className="pro-summary-section">
                          <div className="pro-summary-title">
                            <div className="pro-section-icon">
                              <i className="bi bi-heart-pulse"></i>
                            </div>
                            <div>
                              <h5>Antecedentes Patológicos</h5>
                              <span>Historial clínico relevante</span>
                            </div>
                          </div>

                          <div className="pro-summary-content">
                            {tieneAntecedentes() ? (
                              <div className="d-flex flex-wrap gap-2">
                                <span
                                  className={`pro-badge info ${
                                    tappctesData.checke1 ? "d-inline-flex" : "d-none"
                                  }`}
                                >
                                  Cardiopatías
                                </span>
                                <span
                                  className={`pro-badge info ${
                                    tappctesData.checke2 ? "d-inline-flex" : "d-none"
                                  }`}
                                >
                                  Diabetes
                                </span>
                                <span
                                  className={`pro-badge info ${
                                    tappctesData.checke3 ? "d-inline-flex" : "d-none"
                                  }`}
                                >
                                  Enfermedades Infecciosas
                                </span>

                                <span
                                  className={`pro-badge info ${
                                    tappctesData.checke4 ? "d-inline-flex" : "d-none"
                                  }`}
                                >
                                  HTA
                                </span>
                                <span
                                  className={`pro-badge info ${
                                    tappctesData.checke5 ? "d-inline-flex" : "d-none"
                                  }`}
                                >
                                  Infertilidad
                                </span>
                                <span
                                  className={`pro-badge info ${
                                    tappctesData.checke6 ? "d-inline-flex" : "d-none"
                                  }`}
                                >
                                  Edampsia
                                </span>
                                <span
                                  className={`pro-badge info ${
                                    tappctesData.checke7 ? "d-inline-flex" : "d-none"
                                  }`}
                                >
                                  Alergias
                                </span>
                                <span
                                  className={`pro-badge info ${
                                    tappctesData.checke8 ? "d-inline-flex" : "d-none"
                                  }`}
                                >
                                  Asma Bronquial
                                </span>
                                <span
                                  className={`pro-badge info ${
                                    tappctesData.checke9 ? "d-inline-flex" : "d-none"
                                  }`}
                                >
                                  Cirugías
                                </span>
                                <span
                                  className={`pro-badge info ${
                                    tappctesData.checke10 ? "d-inline-flex" : "d-none"
                                  }`}
                                >
                                  Úlceras
                                </span>
                                <span
                                  className={`pro-badge info ${
                                    tappctesData.checke11 ? "d-inline-flex" : "d-none"
                                  }`}
                                >
                                  Epilepsia
                                </span>
                                <span
                                  className={`pro-badge info ${
                                    tappctesData.checke12 ? "d-inline-flex" : "d-none"
                                  }`}
                                >
                                  Neoplasias
                                </span>
                                <span
                                  className={`pro-badge info ${
                                    tappctesData.checke13 ? "d-inline-flex" : "d-none"
                                  }`}
                                >
                                  Preeclampsia
                                </span>
                                <span
                                  className={`pro-badge info ${
                                    tappctesData.checke14 ? "d-inline-flex" : "d-none"
                                  }`}
                                >
                                  VIH/SIDA
                                </span>
                                <span
                                  className={`pro-badge info ${
                                    tappctesData.checke15 ? "d-inline-flex" : "d-none"
                                  }`}
                                >
                                  Ninguno
                                </span>
                              </div>
                            ) : (
                              <div className="pro-empty-state">
                                <i className="bi bi-clipboard2-x"></i>
                                <span>
                                  No tiene antecedentes registrados
                                </span>
                              </div>
                            )}
                          </div>
                        </div>

                        {/* =========================================
                            DATOS PACIENTE
                          ========================================= */}

                        <div className="pro-summary-section">
                          <div className="pro-summary-title">
                            <div className="pro-section-icon green">
                              <i className="bi bi-person-vcard"></i>
                            </div>

                            <div>
                              <h5>Información General</h5>
                              <span>Datos básicos del paciente</span>
                            </div>
                          </div>
                          <div className="pro-info-grid">
                            <div className="pro-info-item">
                              <label>Seguridad Social</label>
                              <span>
                                {paciente?.seguroNm || "No especificado"}
                                 
                              </span>
                            </div>

                            <div className="pro-info-item">
                              <label>Nombre del Paciente</label>
                              <span>
                                {paciente.pcteNom} {paciente.pcteNom2}{" "}
                                {paciente.pcteApe1} {paciente.pcteApe2}
                              </span>
                            </div>
                          </div>
                        </div>
                      </Form>
                    </div>

                    {/* =========================================================
                        RIGHT COLUMN
                      ========================================================= */}

                    <div className="col-12 col-xl-6">

                      <div className="pro-summary-section h-100">

                        <div className="pro-summary-title">

                          <div className="pro-section-icon purple">
                            <i className="bi bi-shield-check"></i>
                          </div>

                          <div>
                            <h5>Antecedentes Alérgicos</h5>
                            <span>Información médica complementaria</span>
                          </div>

                        </div>

                        <div className="pro-summary-content">

                          <div className="pro-empty-state">

                            <i className="bi bi-info-circle"></i>

                            <span>
                              Datos de los antecedentes
                            </span>

                          </div>

                        </div>

                      </div>

                    </div>
                    {/* =========================================================
                        EXPANDED INFO
                      ========================================================= */}
                    <div
                      className={`col-12 ${
                        expanded ? "d-block" : "d-none"
                      }`}
                    >

                      <Form>

                        <div className="pro-section-card">

                          <div className="pro-section-title">

                            <div className="pro-section-icon">
                              <i className="bi bi-person-lines-fill"></i>
                            </div>

                            <div>
                              <h4>Información Complementaria</h4>
                              <span>Detalles adicionales del paciente</span>
                            </div>

                          </div>

                          <div className="row g-4">

                            <div className="col-md-6">

                              <div className="pro-info-item">
                                <label>Género</label>
                                <span>{paciente.pcteSx}</span>
                              </div>

                            </div>

                            <div className="col-md-6">

                              <div className="pro-info-item">
                                <label>País</label>
                                <span>{paciente.pcteNac}</span>
                              </div>

                            </div>

                            <div className="col-md-6">

                              <div className="pro-info-item">
                                <label>Provincia</label>
                                <span>{paciente.pcteProv}</span>
                              </div>

                            </div>

                            <div className="col-md-6">

                              <div className="pro-info-item">
                                <label>Ciudad</label>
                                <span>{paciente.pcteCiud}</span>
                              </div>

                            </div>

                          </div>

                        </div>

                      </Form>

                    </div>

                  </div>
                </div>

              {/* =========================================================
                  BUTTON EXPAND
                ========================================================= */}

              <div className="pro-summary-toggle-wrapper">

                <button
                  className="pro-btn-expand"
                  type="button"
                  onClick={handleToggleSize}
                >

                  <span>
                    {expanded
                      ? "Ocultar Información"
                      : "Conoce más Información del paciente"}
                  </span>

                  <i
                    className={`bi bi-arrow-${expanded ? "up" : "down"}`}
                  ></i>

                </button>

              </div>

              </div>

              <div className="row g-4 align-items-stretch">
                <Col lg={8} md={12}>

                  <FormGroup floating className="pro-floating-group h-100">

                    <Input
                      type="select"
                      className="form-control pro-input pro-select"
                      id="categoryId"
                      value={paciente.categoryId}
                      onChange={(e) => setCategoryId(e.target.value)}
                      placeholder="Category"
                    >

                      {categoryData
                        .sort((a, b) => a.categoryId - b.categoryId)
                        .map((category) => (

                          <option
                            key={category.categoryId}
                            value={category.categoryId.toString()}
                          >

                            {category.categoryNm}

                          </option>

                        ))}

                    </Input>

                    <Label for="categoryId">

                      <div className="d-flex align-items-center gap-2">

                        <i className="bi bi-clipboard2-pulse"></i>

                        <span>Tipo de Consulta</span>

                        <span className="text-danger fw-bold">*</span>

                      </div>

                    </Label>

                  </FormGroup>

                </Col>

                <Col lg={4} md={12}>

                  <div className="pro-exp-card">

                    <div className="pro-exp-card-icon">

                      <i className="bi bi-file-earmark-medical"></i>

                    </div>

                    <div className="pro-exp-card-content">

                      <span className="pro-exp-label">

                        Número de Expediente

                      </span>

                      <h4 className="pro-exp-number">

                        {ultimaConsultaAll}

                      </h4>

                    </div>

                  </div>

                </Col>

              </div>
              {/* Tipo de Consulta */}

              <div className="consultation-section">
                <div className="row g-4">
                {/* ===================================================== */}
                {/* MOTIVO + OBSERVACIONES */}
                {/* ===================================================== */}
                <Col xs={12} xl={6}>
                  <div className="medical-card h-100">
                    <div className="medical-card-header">
                      <div>
                        <h6 className="medical-card-title">
                          Enfermedad actual y Motivo de la Consulta
                          <span className="text-danger fw-bold ms-1">*</span>
                        </h6>
                        <small className="medical-card-subtitle">
                          Describa los síntomas y motivo principal
                        </small>
                      </div>
                    </div>
                    <FormGroup className="mb-0">
                      <Label className="pro-label">
                        Motivo de la Consulta
                      </Label>
                      <div
                        className="position-relative"
                        // Bloquear escritura cuando llegue al máximo
                        onBeforeInputCapture={(e) => {
                          const currentLength =
                            getPlainTextLength(consultMot || "");
                          const newText = e.data || "";
                          // Ya llegó al máximo
                          if (currentLength >= maxChars1) {
                            e.preventDefault();
                            return;
                          }
                          // Lo que intenta escribir excedería el máximo
                          if (
                            currentLength + newText.length >
                            maxChars1
                          ) {
                            e.preventDefault();
                          }
                        }}
                        // Bloquear pegado si excede el máximo
                        onPasteCapture={(e) => {
                          const currentLength =
                            getPlainTextLength(consultMot || "");
                          const pastedText =
                            e.clipboardData?.getData("text") || "";
                          if (
                            currentLength + pastedText.length >
                            maxChars1
                          ) {
                            e.preventDefault();
                          }
                        }}
                      >
                        <ProRichTextEditor
                          value={consultMot || ""}
                          onChange={(html) => {
                            const plainTextLength =
                              getPlainTextLength(html);
                            // Protección adicional:
                            // nunca guardar más del máximo
                            if (plainTextLength <= maxChars1) {
                              setConsultMot(html);
                            }
                          }}
                          placeholder="Motivo de la Consulta..."
                        />
                        <div className="pro-rich-counter">
                          {Math.max(
                            0,
                            maxChars1 -
                              getPlainTextLength(consultMot || "")
                          )}
                          /{maxChars1}
                        </div>
                      </div>
                    </FormGroup>
                  </div>
                </Col>

                {/* OBSERVACIONES */}

                <Col xs={12} xl={6}>
                  <div className="medical-card h-100">
                    <div className="medical-card-header">
                      <div>
                        <h6 className="medical-card-title">
                          Observaciones
                          <span className="text-danger fw-bold ms-1">*</span>
                        </h6>
                        <small className="medical-card-subtitle">
                          Información clínica complementaria
                        </small>
                      </div>
                    </div>
                    <FormGroup className="mb-0">
                      <Label className="pro-label">
                        Observaciones
                      </Label>
                      <div
                        className="position-relative"
                        // Bloquear escritura cuando llegue al máximo
                        onBeforeInputCapture={(e) => {
                          const currentLength =
                            getPlainTextLength(consultHea || "");
                          const newText = e.data || "";
                          // Ya llegó al máximo
                          if (currentLength >= maxChars1) {
                            e.preventDefault();
                            return;
                          }
                          // Lo que intenta escribir excedería el máximo
                          if (
                            currentLength + newText.length >
                            maxChars1
                          ) {
                            e.preventDefault();
                          }
                        }}
                        // Bloquear pegado si excede el máximo
                        onPasteCapture={(e) => {
                          const currentLength =
                            getPlainTextLength(consultHea || "");
                          const pastedText =
                            e.clipboardData?.getData("text") || "";
                          // Bloquear si el pegado excedería el máximo
                          if (
                            currentLength + pastedText.length >
                            maxChars1
                          ) {
                            e.preventDefault();
                          }
                        }}
                      >
                        <ProRichTextEditor
                          value={consultHea || ""}
                          onChange={(html) => {
                            const plainTextLength =
                              getPlainTextLength(html);
                            // Nunca guardar contenido
                            // por encima del máximo
                            if (plainTextLength <= maxChars1) {
                              setConsultHea(html);
                            }
                          }}
                          placeholder="Observaciones..."
                        />
                        <div className="pro-rich-counter">
                          {Math.max(
                            0,
                            maxChars1 -
                              getPlainTextLength(consultHea || "")
                          )}
                          /{maxChars1}
                        </div>
                      </div>
                    </FormGroup>
                  </div>
                </Col>

                {/* ===================================================== */}
                {/* CONSULTA ANTERIOR */}
                {/* ===================================================== */}

                <Col xs={12}>
                  <div className="medical-card medical-card-disabled">

                    <div className="medical-card-header">
                      <div>
                        <h6 className="medical-card-title">
                          Consulta Anterior
                        </h6>
                        <small className="medical-card-subtitle">
                          Histórico clínico registrado
                        </small>
                      </div>
                    </div>

                   <FormGroup className="mb-0">
                    <Label className="pro-label">
                      Consulta Anterior
                    </Label>
                    <div
                      className="consult-old-rich"
                      dangerouslySetInnerHTML={{
                        __html: consultMotOld || "Sin consulta anterior",
                      }}
                    />
                  </FormGroup>

                  </div>
                </Col>

              </div>
              </div>
              {/* Consultas */}

              <div className="consult-tabs-wrapper">
                <Row>
                  <Form
                    className="w-100"
                    onSubmit={SaveConsult}
                    style={{
                      marginBottom: "1rem",
                    }}
                  >
                    <Col md={12}>
                      <div className="consult-card-pro">
                        
                        {/* HEADER TABS */}
                        <div className="consult-card-header pro-card-header-text">
                          <label className="fs-4 fw-bold text-primary mb-0m,566n">
                            Evaluación Clínica
                          </label>

                          <Nav tabs className="consult-tabs-nav text-uppercase">
                            <NavItem>
                              <NavLink
                                className={activeTab === "1" ? "active" : ""}
                                onClick={() => toggleTab("1")}
                              >
                                Ant. Patológicos
                              </NavLink>
                            </NavItem>

                            <NavItem>
                              <NavLink
                                className={activeTab === "2" ? "active" : ""}
                                onClick={() => toggleTab("2")}
                              >
                                Ant. Familiares
                              </NavLink>
                            </NavItem>

                            <NavItem>
                              <NavLink
                                className={activeTab === "3" ? "active" : ""}
                                onClick={() => toggleTab("3")}
                              >
                                Toxicológicos
                              </NavLink>
                            </NavItem>

                            <NavItem>
                              <NavLink
                                className={activeTab === "4" ? "active" : ""}
                                onClick={() => toggleTab("4")}
                              >
                                Exámen Físico
                              </NavLink>
                            </NavItem>
                          </Nav>
                        </div>

                        {/* CONTENT */}
                        <TabContent activeTab={activeTab} className="consult-tab-content">
                          
                          {/* TAB 1 */}
                          <TabPane tabId="1">
                            <div className="consult-pane-body">

                              <div className="section-title-pro">
                                Antecedentes Personales Patológicos
                              </div>

                              <div className="pathology-grid">
                                {[
                                  { id: "checke1", label: "Cardiopatías", checked: tappctesData.checke1 },
                                  { id: "checke2", label: "Diabetes", checked: tappctesData.checke2 },
                                  { id: "checke3", label: "Enfermedades Infecciosas", checked: tappctesData.checke3 },
                                  { id: "checke4", label: "HTA", checked: tappctesData.checke4 },
                                  { id: "checke5", label: "Infertilidad", checked: tappctesData.checke5 },
                                  { id: "checke6", label: "Edampsia", checked: tappctesData.checke6 },
                                  { id: "checke7", label: "Alergias", checked: tappctesData.checke7 },
                                  { id: "checke8", label: "Asma Bronquial", checked: tappctesData.checke8 },
                                  { id: "checke9", label: "Cirugías", checked: tappctesData.checke9 },
                                  { id: "checke10", label: "Úlceras", checked: tappctesData.checke10 },
                                  { id: "checke11", label: "Epilepsia", checked: tappctesData.checke11 },
                                  { id: "checke12", label: "Neoplasias", checked: tappctesData.checke12 },
                                  { id: "checke13", label: "Preeclamsia", checked: tappctesData.checke13 },
                                  { id: "checke14", label: "VIH/SIDA", checked: tappctesData.checke14 },
                                  { id: "checke15", label: "Ninguno", checked: tappctesData.checke15 }
                                ].map(({ id, label, checked }) => (
                                  <div className="pathology-item" key={id}>
                                    <FormGroup switch className="m-0">
                                      <Input
                                        id={id}
                                        type="checkbox"
                                        checked={checked}
                                        onChange={(e) =>
                                          setTappctesData({
                                            ...tappctesData,
                                            [id]: e.target.checked,
                                          })
                                        }
                                      />
                                      <Label check>{label}</Label>
                                    </FormGroup>
                                  </div>
                                ))}
                              </div>

                              <div className="row g-4 mt-1">
                                <div className="col-lg-6">
                                  <FormGroup floating>
                                    <Input
                                      type="textarea"
                                      className="form-control textarea-pro"
                                      id="antOtros"
                                      value={tappctesData.antOtros}
                                      onChange={(e) =>
                                        setTappctesData({
                                          ...tappctesData,
                                          antOtros: e.target.value,
                                        })
                                      }
                                      placeholder="Otros antecedentes"
                                      maxLength={maxChars3}
                                    />
                                    <Label for="antOtros">Otros Antecedentes</Label>

                                    <div className="char-counter-pro">
                                      {maxChars3 - (tappctesData.antOtros?.length || 0)}/{maxChars3}
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-lg-6">
                                  <FormGroup floating>
                                    <Input
                                      type="textarea"
                                      className="form-control textarea-pro"
                                      id="antFarmacos"
                                      value={tappctesData.antFarmacos}
                                      onChange={(e) =>
                                        setTappctesData({
                                          ...tappctesData,
                                          antFarmacos: e.target.value,
                                        })
                                      }
                                      placeholder="Fármacos"
                                      maxLength={maxChars3}
                                    />
                                    <Label for="antFarmacos">Fármacos</Label>

                                    <div className="char-counter-pro">
                                      {maxChars3 - (tappctesData.antFarmacos?.length || 0)}/{maxChars3}
                                    </div>
                                  </FormGroup>
                                </div>
                              </div>
                            </div>
                          </TabPane>

                          {/* TAB 2 */}
                          <TabPane tabId="2">
                            <div className="consult-pane-body">

                              <div className="row g-4">

                                <div className="col-xl-6">
                                  <div className="mini-card-pro">
                                    <label className="mini-card-title">
                                      Antecedentes No Patológicos
                                    </label>

                                    <div className="row g-3 mt-1">
                                      <Col md={6}>
                                        <FormGroup floating>
                                          <Input
                                            type="text"
                                            id="mquirur"
                                            value={tappctesData.mquirur}
                                            onChange={(e) =>
                                              setTappctesData({
                                                ...tappctesData,
                                                mquirur: e.target.value,
                                              })
                                            }
                                          />
                                          <Label>Quirúrgicos</Label>
                                        </FormGroup>
                                      </Col>

                                      <Col md={6}>
                                        <FormGroup floating>
                                          <Input
                                            type="text"
                                            id="malergi"
                                            value={tappctesData.malergi}
                                            onChange={(e) =>
                                              setTappctesData({
                                                ...tappctesData,
                                                malergi: e.target.value,
                                              })
                                            }
                                          />
                                          <Label>Alérgicos</Label>
                                        </FormGroup>
                                      </Col>

                                      <Col md={6}>
                                        <FormGroup floating>
                                          <Input
                                            type="text"
                                            id="mtrauma"
                                            value={tappctesData.mtrauma}
                                            onChange={(e) =>
                                              setTappctesData({
                                                ...tappctesData,
                                                mtrauma: e.target.value,
                                              })
                                            }
                                          />
                                          <Label>Traumáticos</Label>
                                        </FormGroup>
                                      </Col>

                                      <Col md={6}>
                                        <FormGroup floating>
                                          <Input
                                            type="text"
                                            id="mtransf"
                                            value={tappctesData.mtransf}
                                            onChange={(e) =>
                                              setTappctesData({
                                                ...tappctesData,
                                                mtransf: e.target.value,
                                              })
                                            }
                                          />
                                          <Label>Transfusionales</Label>
                                        </FormGroup>
                                      </Col>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-xl-6">
                                  <div className="mini-card-pro">
                                    <label className="mini-card-title">
                                      Antecedentes Heredo-Familiares
                                    </label>

                                    <div className="row g-3 mt-1">
                                      <Col md={6}>
                                        <FormGroup floating>
                                          <Input
                                            type="text"
                                            id="mmadre"
                                            value={tappctesData.mmadre}
                                            onChange={(e) =>
                                              setTappctesData({
                                                ...tappctesData,
                                                mmadre: e.target.value,
                                              })
                                            }
                                          />
                                          <Label>Madre</Label>
                                        </FormGroup>
                                      </Col>

                                      <Col md={6}>
                                        <FormGroup floating>
                                          <Input
                                            type="text"
                                            id="mpadre"
                                            value={tappctesData.mpadre}
                                            onChange={(e) =>
                                              setTappctesData({
                                                ...tappctesData,
                                                mpadre: e.target.value,
                                              })
                                            }
                                          />
                                          <Label>Padre</Label>
                                        </FormGroup>
                                      </Col>

                                      <Col md={6}>
                                        <FormGroup floating>
                                          <Input
                                            type="text"
                                            id="mconyu"
                                            value={tappctesData.mconyu}
                                            onChange={(e) =>
                                              setTappctesData({
                                                ...tappctesData,
                                                mconyu: e.target.value,
                                              })
                                            }
                                          />
                                          <Label>Cónyuge</Label>
                                        </FormGroup>
                                      </Col>

                                      <Col md={6}>
                                        <FormGroup floating>
                                          <Input
                                            type="text"
                                            id="motros"
                                            value={tappctesData.motros}
                                            onChange={(e) =>
                                              setTappctesData({
                                                ...tappctesData,
                                                motros: e.target.value,
                                              })
                                            }
                                          />
                                          <Label>Otros</Label>
                                        </FormGroup>
                                      </Col>
                                    </div>
                                  </div>
                                </div>

                              </div>

                            </div>
                          </TabPane>

                          {/* TAB 3 */}
                          <TabPane tabId="3">
                            <div className="consult-pane-body">

                              <div className="section-title-pro">
                                Antecedentes Toxicológicos
                              </div>

                              <div className="tox-grid">
                                <FormGroup switch>
                                  <Input
                                    id="toxicChecke1"
                                    type="checkbox"
                                    checked={tappctesData.toxicChecke1}
                                    onChange={(e) =>
                                      setTappctesData({
                                        ...tappctesData,
                                        toxicChecke1: e.target.checked,
                                      })
                                    }
                                  />
                                  <Label check>Drogas</Label>
                                </FormGroup>

                                <FormGroup switch>
                                  <Input
                                    id="toxicChecke2"
                                    type="checkbox"
                                    checked={tappctesData.toxicChecke2}
                                    onChange={(e) =>
                                      setTappctesData({
                                        ...tappctesData,
                                        toxicChecke2: e.target.checked,
                                      })
                                    }
                                  />
                                  <Label check>Tabaquismo</Label>
                                </FormGroup>

                                <FormGroup switch>
                                  <Input
                                    id="toxicChecke3"
                                    type="checkbox"
                                    checked={tappctesData.toxicChecke3}
                                    onChange={(e) =>
                                      setTappctesData({
                                        ...tappctesData,
                                        toxicChecke3: e.target.checked,
                                      })
                                    }
                                  />
                                  <Label check>Consumo Alcohol</Label>
                                </FormGroup>
                              </div>

                              <div className="mt-4">
                               <FormGroup floating>
                                  <Input
                                    type="textarea"
                                    className="form-control textarea-pro"
                                    id="toxicOtros"
                                    value={tappctesData.toxicOtros}
                                    onChange={(e) =>
                                      setTappctesData({
                                        ...tappctesData,
                                        toxicOtros: e.target.value,
                                      })
                                    }
                                    placeholder="Otros"
                                  />
                                  <Label>Otros (Opcional)</Label>
                                </FormGroup>
                              </div>

                            </div>
                          </TabPane>

                          {/* TAB 4 */}
                          <TabPane tabId="4">
                            <div className="consult-pane-body">

                              <div className="section-title-pro">
                                Exámen Físico
                              </div>

                              {/* ================================================= */}
                              {/* SIGNOS VITALES */}
                              {/* ================================================= */}

                              <div className="exam-grid">

                                {[
                                  { id: "exam1", value: exam1, set: setExam1, placeholder: "F.C" },
                                  { id: "exam2", value: exam2, set: setExam2, placeholder: "F.R" },
                                  { id: "exam3", value: exam3, set: setExam3, placeholder: "P.ABD" },
                                  { id: "exam4", value: exam4, set: setExam4, placeholder: "Temperatura" },
                                  { id: "exam5", value: exam5, set: setExam5, placeholder: "Talla" },
                                ].map((item) => (
                                  <FormGroup key={item.id}>
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id={item.id}
                                      value={item.value}
                                      onChange={(e) => item.set(e.target.value)}
                                      placeholder={item.placeholder}
                                    />
                                  </FormGroup>
                                ))}

                                {/* PESO */}
                                <FormGroup>
                                  <div className="d-flex align-items-center gap-2">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="exam6"
                                      value={exam6}
                                      onChange={(e) => setExam6(e.target.value)}
                                      placeholder="Peso"
                                    />
                                    <label className="fw-bold mb-0">
                                      Lbs.
                                    </label>
                                  </div>
                                </FormGroup>

                                {/* KG */}
                                <FormGroup>
                                  <div className="d-flex align-items-center gap-2">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="exam6kg"
                                      value={(exam6 * 0.45359237).toFixed(1)}
                                      placeholder="Kg."
                                      disabled
                                    />
                                    <label className="fw-bold mb-0">
                                      Kg.
                                    </label>
                                  </div>
                                </FormGroup>

                                {/* IMC */}
                                <FormGroup>
                                  <div className="d-flex align-items-center gap-2">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="exam7"
                                      value={exam7}
                                      placeholder="IMC"
                                      disabled
                                    />
                                    <label className="fw-bold mb-0">
                                      Kg/M²
                                    </label>
                                  </div>
                                </FormGroup>

                              </div>

                              {/* ================================================= */}
                              {/* EXAMEN GENERAL */}
                              {/* ================================================= */}

                              <div className="exam-grid mt-4">

                                {[
                                  { id: "exam8", value: exam8, set: setExam8, placeholder: "Corazón" },
                                  { id: "exam9", value: exam9, set: setExam9, placeholder: "Cuello" },
                                  { id: "exam10", value: exam10, set: setExam10, placeholder: "Pulmón" },
                                  { id: "exam11", value: exam11, set: setExam11, placeholder: "M.I" },
                                  { id: "exam12", value: exam12, set: setExam12, placeholder: "T.A B Izquierdo" },
                                  { id: "exam13", value: exam13, set: setExam13, placeholder: "T.A B Derecho" },
                                  { id: "exam14", value: exam14, set: setExam14, placeholder: "TA Decúbico" },
                                  { id: "exam15", value: exam15, set: setExam15, placeholder: "Cabeza" },
                                  { id: "exam16", value: exam16, set: setExam16, placeholder: "Torax" },
                                  { id: "exam17", value: exam17, set: setExam17, placeholder: "Abdomen" },
                                  { id: "exam18", value: exam18, set: setExam18, placeholder: "Especuloscopia" },
                                ].map((item) => (
                                  <FormGroup key={item.id}>
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id={item.id}
                                      value={item.value}
                                      onChange={(e) => item.set(e.target.value)}
                                      placeholder={item.placeholder}
                                    />
                                  </FormGroup>
                                ))}

                              </div>

                              {/* ================================================= */}
                              {/* COMENTARIO */}
                              {/* ================================================= */}

                              <div className="mt-4">
                                <FormGroup>
                                  <Input
                                    type="textarea"
                                    className="form-control textarea-pro"
                                    id="examComentario"
                                    value={examComentario}
                                    onChange={(e) =>
                                      setExamComentario(e.target.value)
                                    }
                                    placeholder="Comentario General"
                                  />
                                </FormGroup>
                              </div>

                            </div>
                          </TabPane>

                        </TabContent>
                      </div>
                    </Col>
                  </Form>
                </Row>
              </div>
              {/* Tabs de Patologia */}

              <div className="pro-card gabinete-card mb-4">
                <div className="pro-card-header">
                  <div className="pro-card-header-text">
                    <h5 className="fs-4 fw-bold text-primary mb-0m,566n">
                      Estudio de Gabinete
                    </h5>

                    <span className="pro-card-subtitle">
                      Resultados, observaciones y comentarios clínicos complementarios
                    </span>
                  </div>

                  <div className="gabinete-badge">
                    <i className="bi bi-clipboard2-pulse-fill"></i>
                    Complementario
                  </div>
                </div>

                <div className="pro-card-body">
                  <Row className="g-4 align-items-stretch">
                    <Col lg={8}>
                      <FormGroup className="pro-floating">
                        <Label className="pro-label">
                          Estudio de Gabinete (Opcional)
                        </Label>

                        <div
                          className="position-relative"
                          // Bloquear escritura cuando llegue al máximo
                          onBeforeInputCapture={(e) => {
                            const currentLength =
                              getPlainTextLength(estGabinete || "");
                            const newText = e.data || "";
                            // Si ya llegó al máximo, bloquear
                            if (currentLength >= maxChars2) {
                              e.preventDefault();
                              return;
                            }
                            // Si el nuevo texto excedería el máximo, bloquear
                            if (
                              currentLength + newText.length >
                              maxChars2
                            ) {
                              e.preventDefault();
                            }
                          }}
                          // Bloquear pegado si excede el máximo
                          onPasteCapture={(e) => {
                            const currentLength =
                              getPlainTextLength(estGabinete || "");
                            const pastedText =
                              e.clipboardData?.getData("text") || "";
                            if (
                              currentLength + pastedText.length >
                              maxChars2
                            ) {
                              e.preventDefault();
                            }
                          }}
                        >
                          <ProRichTextEditor
                            value={estGabinete || ""}
                            onChange={(html) => {
                              const plainTextLength =
                                getPlainTextLength(html);
                              // Nunca guardar contenido por encima del máximo
                              if (plainTextLength <= maxChars2) {
                                setEstGabinete(html);
                              }
                            }}
                            placeholder="Estudio de Gabinete..."
                          />
                          <div className="pro-rich-counter">
                            {Math.max(
                              0,
                              maxChars2 -
                                getPlainTextLength(estGabinete || "")
                            )}
                            /{maxChars2}
                          </div>
                        </div>
                      </FormGroup>
                    </Col>

                    <Col lg={4}>
                      <div className="gabinete-info-card">
                        <div className="gabinete-icon">
                          <i className="bi bi-file-earmark-medical-fill"></i>
                        </div>

                        <h6>Información Médica</h6>

                        <p>
                          Registra imágenes diagnósticas, estudios especiales,
                          observaciones clínicas y resultados complementarios.
                        </p>

                        <div className="gabinete-tags">
                          <span>RX</span>
                          <span>Sonografía</span>
                          <span>MRI</span>
                          <span>CT Scan</span>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
              {/* Estudio de Gabinete */}

              <div className="medical-card medical-card--lab mb-4">
                <div className="medical-card__header">
                  <div className="pro-card-header-text">
                    <h5 className="fs-4 fw-bold text-primary mb-0m,
                    566n ">
                      Resultados de laboratorio clínico
                    </h5>
                    <p className="medical-card__subtitle">
                      Registro y consulta de análisis clínicos del paciente
                    </p>
                  </div>

                  <button
                    type="button"
                    className="button-access__new d-flex align-items-center gap-2"
                    onClick={() => setOpenModalResultadoLab(true)}
                  >
                    <i className="bi bi-plus-circle-fill"></i>
                    Agregar Resultado
                  </button>
                </div>

                <div className="medical-card__body">
                  <FormGroup className="modern-floating">
                    <Label className="pro-label">
                      Comentario del resultado (Opcional)
                    </Label>
                    <div
                      className="position-relative"
                      // Bloquear escritura cuando llegue al máximo
                      onBeforeInputCapture={(e) => {
                        const currentLength =
                          getPlainTextLength(resultLab || "");
                        const newText = e.data || "";
                        // Si ya llegó al máximo, bloquear
                        if (currentLength >= maxChars1) {
                          e.preventDefault();
                          return;
                        }
                        // Si el nuevo texto excedería el máximo, bloquear
                        if (
                          currentLength + newText.length >
                          maxChars1
                        ) {
                          e.preventDefault();
                        }
                      }}
                      // Bloquear pegado si excede el máximo
                      onPasteCapture={(e) => {
                        const currentLength =
                          getPlainTextLength(resultLab || "");
                        const pastedText =
                          e.clipboardData?.getData("text") || "";
                        if (
                          currentLength + pastedText.length >
                          maxChars1
                        ) {
                          e.preventDefault();
                        }
                      }}
                    >
                      <ProRichTextEditor
                        value={resultLab || ""}
                        onChange={(html) => {
                          const plainTextLength =
                            getPlainTextLength(html);
                          // Nunca guardar contenido por encima del máximo
                          if (plainTextLength <= maxChars1) {
                            setResultLab(html);
                          }
                        }}
                        placeholder="Resultado de Laboratorio..."
                      />
                      <div className="pro-rich-counter">
                        {Math.max(
                          0,
                          maxChars1 -
                            getPlainTextLength(resultLab || "")
                        )}
                        /{maxChars1}
                      </div>
                    </div>
                  </FormGroup>
                </div>

                {/* =========================================================
                    MODAL
                  ========================================================= */}

                <Modal
                  isOpen={openModalResultadoLab}
                  toggle={() => setOpenModalResultadoLab(false)}
                  centered
                  scrollable
                  size="xl"
                  modalClassName="modal-lab-pro"
                >
                  <ModalHeader
                    toggle={() => setOpenModalResultadoLab(false)}
                    className="modal-lab-header"
                  >
                    <div>
                      <h4 className="mb-1 fw-bold">
                        Mantenimiento de Análisis
                      </h4>

                      <small className="text-muted">
                        Gestión completa de resultados clínicos
                      </small>
                    </div>
                  </ModalHeader>

                  <ModalBody className="modal-lab-body">
                    <Form onSubmit={SaveConsult}>
                      {/* =========================================
                          TABS
                        ========================================= */}

                      <Nav tabs className="lab-tabs">
                        <NavItem>
                          <NavLink
                            className={activeTabLab === "1" ? "active" : ""}
                            onClick={() => toggleTabLab("1")}
                          >
                            <i className="bi bi-clipboard2-pulse me-2"></i>
                            Mantenimiento
                          </NavLink>
                        </NavItem>

                        <NavItem>
                          <NavLink
                            className={activeTabLab === "2" ? "active" : ""}
                            onClick={() => toggleTabLab("2")}
                          >
                            <i className="bi bi-table me-2"></i>
                            Consulta
                          </NavLink>
                        </NavItem>
                      </Nav>

                      <TabContent activeTab={activeTabLab}>
                        {/* =====================================================
                            TAB 1
                          ===================================================== */}

                        <TabPane tabId="1">
                          <div className="lab-analysis-wrapper">

                            <div className="lab-analysis-header">
                              <div>
                                <h5 className="fw-bold text-primary mb-1">
                                  Hemograma Completo
                                </h5>

                                <p className="text-muted mb-0">
                                  Complete los resultados del análisis clínico
                                </p>
                              </div>
                            </div>

                            <div className="lab-grid">
                              {[...Array(43).keys()].map((i) => (
                                <FormGroup
                                  key={i}
                                  floating
                                  className="modern-floating"
                                >
                                  {i < 35 ? (
                                    <Input
                                      type="number"
                                      className="form-control"
                                      id={`analysis${i + 1}`}
                                      value={
                                        analysisValues[`analysis${i + 1}`]
                                      }
                                      onChange={(e) =>
                                        handleAnalysisChange(
                                          `analysis${i + 1}`,
                                          e.target.value
                                        )
                                      }
                                      placeholder=" "
                                    />
                                  ) : i < 39 ? (
                                    <Input
                                      type="select"
                                      className="form-select"
                                      id={`analysis${i + 1}`}
                                      value={
                                        analysisValues[`analysis${i + 1}`]
                                      }
                                      onChange={(e) =>
                                        handleAnalysisChange(
                                          `analysis${i + 1}`,
                                          e.target.value
                                        )
                                      }
                                    >
                                      <option value="">
                                        Seleccione
                                      </option>

                                      <option value="N">
                                        Negativo
                                      </option>

                                      <option value="P">
                                        Positivo
                                      </option>
                                    </Input>
                                  ) : (
                                    <Input
                                      type="textarea"
                                      className="form-control"
                                      id={`analysis${i + 1}`}
                                      value={
                                        analysisValues[`analysis${i + 1}`]
                                      }
                                      onChange={(e) =>
                                        handleAnalysisChange(
                                          `analysis${i + 1}`,
                                          e.target.value
                                        )
                                      }
                                      placeholder=" "
                                      style={{
                                        minHeight: "120px",
                                      }}
                                    />
                                  )}

                                  <Label for={`analysis${i + 1}`}>
                                    {
                                      [
                                        "GB",
                                        "N",
                                        "L",
                                        "Mono",
                                        "Eo",
                                        "GR",
                                        "HB",
                                        "Hcto",
                                        "Mev",
                                        "MCH",
                                        "MCHC",
                                        "PIJ",
                                        "Reticulocitos",
                                        "Hierro Serico",
                                        "Ferritina",
                                        "Capt. de Hierro",
                                        "Det. Vit. B12",
                                        "% Sat. Hierro",
                                        "Det. Acido Fólico",
                                        "LDH",
                                        "Fosfatasa Alcalina",
                                        "AST",
                                        "ALT",
                                        "Bilirrubina Total",
                                        "Bilirrubina Directa",
                                        "Bilirrubina indirecta",
                                        "TC",
                                        "TS",
                                        "TP",
                                        "TPT",
                                        "Eritrosedimentación",
                                        "Calcio",
                                        "Urea",
                                        "Creatinina",
                                        "INR",
                                        "HIV",
                                        "Hepatitis B",
                                        "Hepatitis C",
                                        "PCR",
                                        "Orina",
                                        "Cronológico",
                                        "Cultivos",
                                        "Otros",
                                      ][i]
                                    }
                                  </Label>
                                </FormGroup>
                              ))}
                            </div>

                            {/* FOOTER */}

                            <div className="lab-actions">
                              <Button
                                className="pro-btn-save btn btn-secondary"
                                onClick={saveAnalysis}
                              >
                                <i className="bi bi-floppy me-2"></i>
                                Guardar
                              </Button>

                              <Button
                                type="button"
                                onClick={() =>
                                  setOpenModalResultadoLab(false)
                                }
                                className="pro-btn-cancel"
                              >
                                <i className="bi bi-x-circle me-2"></i>
                                Cancelar
                              </Button>
                            </div>
                          </div>
                        </TabPane>

                        {/* =====================================================
                            TAB 2
                          ===================================================== */}

                        <TabPane tabId="2">
                          <div className="lab-table-wrapper">

                            <div className="lab-analysis-header mb-3">
                              <div>
                                <h5 className="fw-bold text-primary mb-1">
                                  Historial de análisis
                                </h5>

                                <p className="text-muted mb-0">
                                  Consulta de resultados guardados
                                </p>
                              </div>
                            </div>

                            <div className="table-responsive">
                              <table className="table table-hover align-middle custom-lab-table">
                                <thead>
                                  <tr>
                                    <th>ID</th>
                                    <th>Fecha</th>

                                    {Array.from({ length: 43 }).map(
                                      (_, i) => (
                                        <th key={i}>
                                          {
                                            [
                                              "GB",
                                              "N",
                                              "L",
                                              "Mono",
                                              "Eo",
                                              "GR",
                                              "HB",
                                              "Hcto",
                                              "Mev",
                                              "MCH",
                                              "MCHC",
                                              "PIJ",
                                              "Reticulocitos",
                                              "Hierro",
                                              "Ferritina",
                                              "Capt. Hierro",
                                              "Vit. B12",
                                              "% Sat.",
                                              "Ácido F.",
                                              "LDH",
                                              "F. Alcalina",
                                              "AST",
                                              "ALT",
                                              "BT",
                                              "BD",
                                              "BI",
                                              "TC",
                                              "TS",
                                              "TP",
                                              "TPT",
                                              "Eritro",
                                              "Calcio",
                                              "Urea",
                                              "Creatinina",
                                              "INR",
                                              "HIV",
                                              "HB",
                                              "HC",
                                              "PCR",
                                              "Orina",
                                              "Crono",
                                              "Cultivos",
                                              "Otros",
                                            ][i]
                                          }
                                        </th>
                                      )
                                    )}
                                  </tr>
                                </thead>

                                <tbody>
                                  {analysisData.map((analisis) => (
                                    <tr key={analisis.analysiId}>
                                      <td>{analisis.analysiId}</td>

                                      <td>
                                        {analisis.analysiFec}
                                      </td>

                                      {Array.from({
                                        length: 43,
                                      }).map((_, i) => (
                                        <td key={i}>
                                          {
                                            analisis[
                                              `analysis${i + 1}`
                                            ]
                                          }
                                        </td>
                                      ))}
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </TabPane>
                      </TabContent>
                    </Form>
                  </ModalBody>
                </Modal>
              </div>
              {/* Resultado de Laboratorio */}

              <div className="medical-card medical-card--diagnosis mb-4">
                {/* HEADER */}

              <div className="medical-card__header">
                <div className="pro-card-header-text">
                  <h5 className="fs-4 fw-bold text-primary mb-0">
                    Diagnóstico
                  </h5>

                  <p className="medical-card__subtitle">
                    Información diagnóstica y clasificación clínica
                  </p>
                </div>
              </div>

                {/* BODY */}

                <div className="medical-card__body">

                  {/* CAUSA EXTERNA */}

                  <Row className="g-3 mb-4">
                    <Col lg={6}>
                      <FormGroup floating className="modern-floating">
                        <Input
                          type="select"
                          className="form-select"
                          id="causeId"
                          value={causeId}
                          onChange={(e) => setCauseId(e.target.value)}
                        >
                          <option value="">
                            Selecciona una Causa Externa
                          </option>

                          {externalCauses.map((cause) => (
                            <option
                              key={cause.causeId}
                              value={cause.causeId.toString()}
                            >
                              {cause.causeNm}
                            </option>
                          ))}
                        </Input>

                        <Label for="causeId">
                          Causa Externa (Opcional)
                        </Label>
                      </FormGroup>
                    </Col>
                  </Row>

                  {/* CIE10 */}

                  <div className="diagnosis-box">

                    <div className="diagnosis-box__header">
                      <div>
                        <h6 className="fw-bold mb-1">
                          Diagnóstico Principal (CIE-10)
                        </h6>

                        <small className="text-muted">
                          Seleccione un diagnóstico clínico
                        </small>
                      </div>

                      <button
                        type="button"
                        className="button-search-pro"
                        onClick={() => openModalCie10()}
                      >
                        <i className="bi bi-search me-2"></i>
                        Buscar CIE-10
                      </button>
                    </div>

                    <div className="d-flex gap-2 align-items-start flex-wrap">

                      <div className="flex-grow-1">
                        <FormGroup className="mb-0">
                          <Input
                            type="text"
                            className="form-control diagnosis-input"
                            id="descriptionCie10"
                            value={descriptionCie10}
                            onChange={(e) =>
                              setDescriptionCie10(e.target.value)
                            }
                            placeholder="Diagnóstico principal (CIE-10)"
                            disabled
                          />
                        </FormGroup>
                      </div>

                      <button
                        type="button"
                        className="btn diagnosis-clear-btn"
                        onClick={() => {
                          setDescriptionCie10("");
                          openModalCie10();
                        }}
                      >
                        <i className="bi bi-x-lg"></i>
                      </button>
                    </div>

                    {/* =====================================================
                        ACCORDION
                      ===================================================== */}

                    <div
                      className="accordion accordion-flush diagnosis-accordion mt-4"
                      id="accordionDiagnostico"
                    >
                      <div className="accordion-item">

                        <h2
                          className="accordion-header"
                          id="flush-headingDiagnostico"
                        >
                          <button
                            className={`accordion-button rounded-4 ${
                              isAccordionDiagnosticoOpen
                                ? ""
                                : "collapsed"
                            }`}
                            type="button"
                            onClick={() => {
                              setIsAccordionDiagnosticoOpen(
                                !isAccordionDiagnosticoOpen
                              );
                            }}
                          >
                            <i className="bi bi-clipboard2-pulse me-2"></i>
                            Información adicional
                          </button>
                        </h2>

                        <div
                          className={`accordion-collapse collapse ${
                            isAccordionDiagnosticoOpen
                              ? "show"
                              : ""
                          }`}
                        >
                          <div className="accordion-body">

                            <Row className="g-4">

                              {/* CLASIFICACIÓN */}

                              <Col lg={6}>
                                <FormGroup floating className="modern-floating">
                                  <Input
                                    type="select"
                                    className="form-select"
                                    id="consultClaDiag"
                                    value={consultClaDiag}
                                    onChange={(e) =>
                                      setConsultClaDiag(e.target.value)
                                    }
                                  >
                                    <option value="">
                                      Selecciona una clasificación
                                    </option>

                                    <option value="Quirúrgico">
                                      Quirúrgico
                                    </option>

                                    <option value="Tóxico">
                                      Tóxico
                                    </option>

                                    <option value="Alérgico">
                                      Alérgico
                                    </option>

                                    <option value="Clínico">
                                      Clínico
                                    </option>

                                    <option value="Patologia">
                                      Patología
                                    </option>

                                    <option value="Otro">
                                      Otro
                                    </option>

                                    <option value="No Aplica">
                                      No Aplica
                                    </option>

                                    <option value="Farmacológico">
                                      Farmacológico
                                    </option>

                                    <option value="Hospitalario">
                                      Hospitalario
                                    </option>

                                    <option value="Traumático">
                                      Traumático
                                    </option>
                                  </Input>

                                  <Label for="consultClaDiag">
                                    Clasificación de diagnóstico
                                    <span className="text-danger fw-bold">
                                      {" "}*
                                    </span>
                                  </Label>
                                </FormGroup>
                              </Col>

                              {/* TIPO */}

                              <Col lg={6}>
                                <FormGroup floating className="modern-floating">
                                  <Input
                                    type="select"
                                    className="form-select"
                                    id="consultTipDiag"
                                    value={consultTipDiag}
                                    onChange={(e) =>
                                      setConsultTipDiag(e.target.value)
                                    }
                                  >
                                    <option value="">
                                      Selecciona un tipo
                                    </option>

                                    <option value="diagnóstico">
                                      Impresión diagnóstico
                                    </option>

                                    <option value="Confirmado">
                                      Confirmado nuevo
                                    </option>

                                    <option value="repetido">
                                      Confirmado repetido
                                    </option>
                                  </Input>

                                  <Label for="consultTipDiag">
                                    Tipo de diagnóstico
                                    <span className="text-danger fw-bold">
                                      {" "}*
                                    </span>
                                  </Label>
                                </FormGroup>
                              </Col>

                              {/* OBSERVACIONES */}

                              <Col lg={12}>
                                <FormGroup
                                  floating
                                  className="modern-floating"
                                >
                                  <Input
                                    type="textarea"
                                    className="form-control medical-textarea"
                                    id="consultDiag"
                                    value={consultDiag}
                                    onChange={(e) =>
                                      setConsultDiag(e.target.value)
                                    }
                                    placeholder="Observaciones"
                                    maxLength={maxChars2}
                                  />

                                  <Label for="consultDiag">
                                    Observaciones (Opcional)
                                  </Label>

                                  <div className="char-counter">
                                    {maxChars2 - consultDiag.length}/
                                    {maxChars2}
                                  </div>
                                </FormGroup>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* =========================================================
                      MODAL CIE10
                    ========================================================= */}

                  <Modal
                    isOpen={isModalCie10Open}
                    toggle={() => setIsModalCie10Open(false)}
                    centered
                    scrollable
                    size="xl"
                    modalClassName="modal-cie10-pro"
                  >
                    <ModalHeader
                      toggle={() => setIsModalCie10Open(false)}
                      className="modal-cie10-header"
                    >
                      <div>
                        <h4 className="fw-bold mb-1">
                          Lista CIE-10
                        </h4>

                        <small className="text-light opacity-75">
                          Buscador inteligente de diagnósticos
                        </small>
                      </div>
                    </ModalHeader>

                    <ModalBody className="modal-cie10-body">

                      {/* SEARCH */}

                      <div className="cie10-search-box">
                        <div className="cie10-search-icon">
                          <i className="bi bi-search"></i>
                        </div>

                        <input
                          className="cie10-search-input"
                          type="text"
                          name="search"
                          id="search"
                          placeholder="Buscar por código o descripción..."
                          value={searchTerm}
                          onChange={(e) =>
                            setSearchTerm(e.target.value)
                          }
                          ref={searchInputRef}
                        />
                      </div>

                      {/* LIST */}

                      <div className="cie10-list">
                        {cie10Data
                          .filter((item) => {
                            return (
                              item.description
                                .toLowerCase()
                                .includes(
                                  searchTerm.toLowerCase()
                                ) ||
                              item.code
                                .toLowerCase()
                                .includes(
                                  searchTerm.toLowerCase()
                                )
                            );
                          })
                          .slice(
                            pagesVisited,
                            pagesVisited + itemsPerPage
                          )
                          .map((item, index) => (
                            <div
                              key={item.code}
                              className={`cie10-item ${
                                index % 2 === 0
                                  ? "even"
                                  : "odd"
                              }`}
                            >
                              <div className="cie10-item__content">
                                <div className="cie10-code">
                                  {item.code}
                                </div>

                                <div className="cie10-description">
                                  {item.description}
                                </div>
                              </div>

                              <button
                                className="button-save cie10-select-btn"
                                type="button"
                                title="Seleccionar CIE-10"
                                onClick={() =>
                                  handleCIE10Selection(item)
                                }
                              >
                                <i className="bi bi-check2-circle"></i>
                              </button>
                            </div>
                          ))}
                      </div>

                      {/* PAGINATION */}

                      <div className="d-flex justify-content-center mt-4">
                        <ReactPaginate
                          previousLabel={"←"}
                          nextLabel={"→"}
                          pageCount={pageCount}
                          onPageChange={handlePageChange}
                          containerClassName={"pagination"}
                          previousLinkClassName={"pagination__link"}
                          nextLinkClassName={"pagination__link"}
                          disabledClassName={
                            "pagination__link--disabled"
                          }
                          activeClassName={
                            "pagination__link--active"
                          }
                          pageRangeDisplayed={5}
                          marginPagesDisplayed={1}
                          breakLabel={"..."}
                          breakClassName={"pagination__link"}
                          breakLinkClassName={"pagination__link"}
                          pageLinkClassName={"pagination__link"}
                          initialPage={0}
                        />
                      </div>
                    </ModalBody>

                    <ModalFooter className="border-0 pt-0">
                      <Button
                        className="pro-btn-cancel"
                        onClick={() =>
                          setIsModalCie10Open(false)
                        }
                      >
                        Cancelar
                      </Button>
                    </ModalFooter>
                  </Modal>
                </div>
              </div>
              {/* Diagnostico */}

              <div
                className="bg-light border rounded-4 shadow-sm p-3 mt-3"
                style={{
                  minHeight: "38rem",
                }}
              >
                {/* HEADER */}
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4">
                  <div className="pro-card-header-text">
                    <label className="fs-4 fw-bold text-primary mb-0">
                      Gestor de Recetas Médicas
                    </label>

                    <div
                      className="text-secondary"
                      style={{ fontSize: ".9rem" }}
                    >
                      Administración y generación de recetas
                    </div>
                  </div>

                  <div className="d-flex gap-2 flex-wrap">
                    <button
                      className="button-access__new"
                      type="button"
                      onClick={handleBuscarMedicamentos}
                    >
                      <i className="bi bi-search pe-1"></i>
                      Buscar medicamento
                    </button>

                    <button
                      className="button-print"
                      type="button"
                      onClick={() =>
                        previsualizarPDF(
                          medicamentos,
                          fechaConsulta,
                          paciente,
                          fechaCita,
                          horaCita,
                          categoryCitaId,
                          notaCita
                        )
                      }
                    >
                      <i className="bi bi-printer-fill pe-1"></i>
                      Imprimir receta
                    </button>
                  </div>
                </div>

                {/* CONTENIDO */}
                <div
                  className="d-flex flex-wrap gap-3"
                  style={{
                    minHeight: "30rem",
                  }}
                >
                  {/* PANEL IZQUIERDO */}
                  <div
                    className="bg-white border rounded-4 shadow-sm p-3"
                    style={{
                      flex: "1 1 320px",
                      maxWidth: "24rem",
                    }}
                  >
                    <div className="mb-3">
                      <FormGroup floating>
                        <Input
                          type="text"
                          className="form-control text-uppercase"
                          id="descripcionMedicamento"
                          value={descripcionMedicamento}
                          onChange={(e) =>
                            setDescripcionMedicamento(e.target.value)
                          }
                          placeholder="Medicamento"
                        />
                        <Label for="descripcionMedicamento">
                          Medicamento
                        </Label>
                      </FormGroup>
                    </div>

                    <div className="mb-3">
                      <FormGroup floating>
                        <Input
                          type="text"
                          className="form-control text-uppercase"
                          id="dosis"
                          value={dosis}
                          onChange={(e) => setDosis(e.target.value)}
                          placeholder="Dosis"
                        />
                        <Label for="dosis">Dosis</Label>
                      </FormGroup>
                    </div>

                    <div className="mb-4">
                      <FormGroup floating>
                        <Input
                          type="text"
                          className="form-control text-uppercase"
                          id="total"
                          value={total}
                          onChange={(e) => setTotal(e.target.value)}
                          placeholder="Total"
                        />
                        <Label for="total">
                          Total (Opcional)
                        </Label>
                      </FormGroup>
                    </div>

                    <div className="d-flex gap-2">
                      <button
                        className="button-send flex-fill"
                        type="button"
                        onClick={handleAddMedicamento}
                        style={{
                          height: "3.5rem",
                        }}
                      >
                        <i className="bi bi-plus-circle-fill pe-1"></i>
                        Agregar
                      </button>
                    </div>
                  </div>

                  {/* PANEL DERECHO */}
                  <div
                    className="bg-white border rounded-4 shadow-sm p-3"
                    style={{
                      flex: "1 1 700px",
                      minWidth: 0,
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <div className="fw-bold text-primary">
                        Medicamentos agregados
                      </div>

                      <span className="badge bg-primary">
                        {medicamentos.length} registros
                      </span>
                    </div>

                    <div
                      className="table-responsive"
                      style={{
                        maxHeight: "28rem",
                        overflowY: "auto",
                      }}
                    >
                      <table className="table table-hover align-middle text-uppercase">
                        <thead
                          className="table-light"
                          style={{
                            position: "sticky",
                            top: 0,
                            zIndex: 1,
                          }}
                        >
                          <tr>
                            <th>Medicamento</th>
                            <th>Dosis</th>
                            <th>Total</th>
                            <th className="text-center">
                              Acción
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {medicamentos.map((medicamento, index) => (
                            <tr
                              key={index}
                              onDoubleClick={() =>
                                handleDoubleClickMedicamento(index)
                              }
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              <td>{medicamento.medicamento}</td>

                              <td>{medicamento.dosis}</td>

                              <td>{medicamento.total}</td>

                              <td className="text-center">
                                <button
                                  className="button-delete text-danger"
                                  type="button"
                                  onClick={() =>
                                    handleDeleteMedicamento(index)
                                  }
                                >
                                  <i className="bi bi-trash3"></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {/* MODAL */}
                <Modal
                  isOpen={isMedicamentosModalOpen}
                  toggle={() => setIsMedicamentosModalOpen(!isMedicamentosModalOpen)}
                  centered
                  size="xl"
                  className="pro-modal-xl modal-medicamentos"
                >

                  {/* ================= HEADER ================= */}
                  <ModalHeader
                    toggle={() => setIsMedicamentosModalOpen(false)}
                    className="pro-modal-header"
                  >
                    <div>
                      <div className="fs-5 fw-bold">
                        Buscar Medicamentos
                      </div>
                      <div className="small opacity-75">
                        Selecciona un medicamento para agregarlo a la receta
                      </div>
                    </div>
                  </ModalHeader>

                  <ModalBody>

                    {/* ================= SEARCH ================= */}
                    <div className="pro-form-card mb-4">

                      <label className="pro-label">
                        Buscar medicamento
                      </label>

                      <input
                        className="pro-input"
                        type="text"
                        placeholder="ID, nombre genérico o comercial..."
                        value={searchTermMedic}
                        onChange={(e) => setSearchTermMedic(e.target.value)}
                        ref={searchInputRef}
                      />

                    </div>

                    {/* ================= TABLE ================= */}
                    <div className="pro-form-card p-0">

                      <div className="table-responsive">

                        <table className="table pro-table align-middle mb-0">

                          <thead>
                            <tr>
                              <th>ID</th>
                              <th>Nombre Genérico</th>
                              <th>Nombre Comercial</th>
                              <th>Dosis</th>
                              <th className="text-center">Acción</th>
                            </tr>
                          </thead>

                          <tbody>
                            {medicamentosSearchResults
                              .filter((medicamento) =>
                                medicamento.producNm.toLowerCase().includes(searchTermMedic.toLowerCase()) ||
                                medicamento.producNc.toLowerCase().includes(searchTermMedic.toLowerCase()) ||
                                medicamento.producId.toString().includes(searchTermMedic)
                              )
                              .sort((a, b) =>
                                a.producNm.localeCompare(b.producNm, "es", {
                                  sensitivity: "base",
                                })
                              )
                              .slice(pagesVisited, pagesVisited + itemsPerPage)
                              .map((medicamento) => (
                                <tr key={medicamento.producId}>
                                  <td>{medicamento.producId}</td>
                                  <td>{medicamento.producNm}</td>
                                  <td>{medicamento.producNc}</td>
                                  <td>{medicamento.producDs}</td>

                                  <td className="text-center">
                                    <button
                                      className="pro-action-btn primary"
                                      onClick={() => handleSelectMedicamento(medicamento)}
                                    >
                                      <i className="bi bi-plus-lg"></i>
                                    </button>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    {/* ================= PAGINATION ================= */}
                    <div className="pro-pagination mt-4">
                      <ul className="pagination modern-pagination flex-wrap">

                        {/* FIRST */}
                        <li className="page-item">
                          <button
                            className="page-link"
                            onClick={() => handlePageChange({ selected: 0 })}
                          >
                            Inicio
                          </button>
                        </li>

                        {/* PREV */}
                        <li className="page-item">
                          <button
                            className="page-link"
                            onClick={() =>
                              handlePageChange({
                                selected: Math.max(0, pageNumber - 1),
                              })
                            }
                          >
                            Anterior
                          </button>
                        </li>

                        {/* NUMEROS */}
                      {Array.from({ length: pageCount })
                        .slice(
                          Math.max(0, pageNumber - 2),
                          Math.min(pageCount, pageNumber + 3)
                        )
                      .map((_, index) => {
                        const pageIndex =
                          Math.max(0, pageNumber - 2) + index;

                        return (
                          <li
                            key={pageIndex}
                            className={`page-item ${
                              pageNumber === pageIndex ? "active" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() =>
                                handlePageChange({ selected: pageIndex })
                              }
                            >
                              {pageIndex + 1}
                            </button>
                          </li>
                        );
                      })}

                        {/* NEXT */}
                        <li className="page-item">
                          <button
                            className="page-link"
                            onClick={() =>
                              handlePageChange({
                                selected: Math.min(pageCount - 1, pageNumber + 1),
                              })
                            }
                          >
                            Siguiente
                          </button>
                        </li>

                      </ul>
                    </div>

                  </ModalBody>

                  {/* ================= FOOTER ================= */}
                  <ModalFooter>

                    <button
                      className="pro-btn-cancel"
                      onClick={() => setIsMedicamentosModalOpen(false)}
                    >
                      Cerrar
                    </button>

                  </ModalFooter>

                </Modal>
              </div>
              {/* Recetas Medicas */}

              <div
                className="bg-light pb-3 border border-light rounded-4 p-3 mt-4 shadow-sm"
                style={{
                  minHeight: isAccordionCitaOpen ? "38rem" : "8rem",
                  transition: "all .3s ease",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                >
                  {/* Header */}
                  <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                    <div className="text-start">
                      <label className="fs-4 fw-bold text-primary">
                        Gestor de Citas Médicas
                      </label>
                      <p className="text-muted mb-0 small">
                        Agenda una próxima consulta para el paciente
                      </p>
                    </div>

                    <div className="form-check form-switch d-flex align-items-center gap-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="flexSwitchCheckDefault"
                        checked={isAccordionCitaOpen}
                        onChange={handleSwitchChange}
                        style={{
                          width: "3.5rem",
                          height: "1.6rem",
                          cursor: "pointer",
                        }}
                      />

                      <label
                        className="form-check-label fw-semibold fs-6"
                        htmlFor="flexSwitchCheckDefault"
                      >
                        ¿Desea agendar una cita?
                      </label>
                    </div>
                  </div>

                  {/* Contenido */}
                  <div
                    className={`collapse ${
                      isAccordionCitaOpen ? "show" : ""
                    } transition-all`}
                  >
                    <div
                      className="border rounded-4 bg-white p-3 shadow-sm"
                      style={{
                        animation: "fadeIn .3s ease",
                      }}
                    >
                      {/* Titulo */}
                      <div className="mb-4">
                        <label className="fw-bold fs-5 text-secondary">
                          Información de la Cita
                        </label>
                      </div>

                      {/* Inputs */}
                      <div className="row g-3 mb-4">
                        {/* Fecha */}
                        <Col lg={4} md={6} sm={12}>
                          <FormGroup floating>
                            <Flatpickr
                              options={{
                                defaultDate: fechaCita || new Date(),
                                onChange: handleFechaCitaChange,
                                locale: {
                                  ...Spanish,
                                  firstDayOfWeek: 0,
                                },
                                dateFormat: "d/m/Y",
                              }}
                              className="form-control rounded-3 shadow-sm"
                            />

                            <Label htmlFor="fechaCita">Fecha</Label>
                          </FormGroup>
                        </Col>

                        {/* Hora */}
                        <Col lg={4} md={6} sm={12}>
                          <FormGroup floating>
                            <Input
                              type="time"
                              className="form-control rounded-3 shadow-sm"
                              id="horaCita"
                              value={horaCita}
                              onChange={handleHoraCitaChange}
                              placeholder="Hora de Cita"
                            />

                            <Label htmlFor="horaFormateada">Hora</Label>
                          </FormGroup>
                        </Col>

                        {/* Tipo Consulta */}
                        <Col lg={4} md={12} sm={12}>
                          <FormGroup floating>
                            <Input
                              type="select"
                              className="form-control rounded-3 shadow-sm"
                              id="categoryCitaId"
                              value={categoryCitaId}
                              onChange={(e) => setCategoryCitaId(e.target.value)}
                              placeholder="CategoryCita"
                            >
                              {categoryData.map((category) => (
                                <option
                                  key={category.categoryId}
                                  value={category.categoryId.toString()}
                                >
                                  {category.categoryNm}
                                </option>
                              ))}
                            </Input>

                            <Label for="categoriaNm">Tipo de Consulta</Label>
                          </FormGroup>
                        </Col>
                      </div>

                      {/* Nota */}
                      <div className="mb-3">
                        <FormGroup>
                          <Label className="pro-label">
                            Nota / Indicaciones de la cita
                          </Label>
                          <div
                            className="position-relative"
                            // Bloquear escritura cuando llegue al máximo
                            onBeforeInputCapture={(e) => {
                              const currentLength =
                                getPlainTextLength(notaCita || "");
                              const newText = e.data || "";
                              // Si ya llegó al máximo, bloquear
                              if (currentLength >= maxChars3) {
                                e.preventDefault();
                                return;
                              }
                              // Si el nuevo texto excedería el máximo, bloquear
                              if (
                                currentLength + newText.length >
                                maxChars3
                              ) {
                                e.preventDefault();
                              }
                            }}
                            // Bloquear pegado si excede el máximo
                            onPasteCapture={(e) => {
                              const currentLength =
                                getPlainTextLength(notaCita || "");
                              const pastedText =
                                e.clipboardData?.getData("text") || "";

                              if (
                                currentLength + pastedText.length >
                                maxChars3
                              ) {
                                e.preventDefault();
                              }
                            }}
                          >
                            <ProRichTextEditor
                              value={notaCita || ""}
                              onChange={(html) => {
                                const plainTextLength =
                                  getPlainTextLength(html);
                                // Nunca guardar contenido por encima del máximo
                                if (plainTextLength <= maxChars3) {
                                  setNotaCita(html);
                                }
                              }}
                              placeholder="Nota / Indicaciones de la cita..."
                            />
                            <div className="pro-rich-counter">
                              {Math.max(
                                0,
                                maxChars3 -
                                  getPlainTextLength(notaCita || "")
                              )}
                              /{maxChars3}
                            </div>

                          </div>
                        </FormGroup>
                      </div>

                      {/* Footer */}
                      <div className="d-flex justify-content-end mt-4">
                        <div
                          className="bg-light border rounded-3 px-3 py-2 text-secondary small"
                        >
                          <i className="bi bi-calendar-check pe-2"></i>
                          La cita será registrada junto con la consulta médica.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Asignar Cita */}

              <div
                className="bg-light border rounded-4 shadow-sm p-3 mt-3"
                style={{
                  minHeight: "30rem",
                }}
              >
                {/* HEADER */}
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4">
                  <div className="pro-card-header-text">
                    <label className="fs-4 fw-bold text-primary mb-0">
                      Referimientos
                    </label>

                    <div
                      className="text-secondary"
                      style={{ fontSize: ".9rem" }}
                    >
                      Gestión y generación de referimientos médicos
                    </div>
                  </div>

                  <button
                    className="button-print"
                    type="button"
                    style={{
                      minWidth: "14rem",
                      height: "3.5rem",
                    }}
                    onClick={() =>
                      previsualizarPDFRecetaControlada(
                        recetaControlada
                      )
                    }
                  >
                    <i className="bi bi-printer-fill pe-2"></i>
                    Imprimir Referimiento
                  </button>
                </div>

                {/* CONTENIDO */}
                <div
                  className="bg-white border rounded-4 shadow-sm p-3"
                  style={{
                    minHeight: "20rem",
                  }}
                >
                  <FormGroup>
                    <Label className="pro-label">
                      Referimientos (Opcional)
                    </Label>

                    <div
                      className="position-relative"

                      // Bloquear escritura cuando llegue al máximo
                      onBeforeInputCapture={(e) => {
                        const currentLength =
                          getPlainTextLength(recetaControlada || "");

                        const newText = e.data || "";

                        // Si ya llegó al máximo, bloquear
                        if (currentLength >= maxChars4) {
                          e.preventDefault();
                          return;
                        }

                        // Si el nuevo texto excedería el máximo, bloquear
                        if (
                          currentLength + newText.length >
                          maxChars4
                        ) {
                          e.preventDefault();
                        }
                      }}

                      // Bloquear pegado si excede el máximo
                      onPasteCapture={(e) => {
                        const currentLength =
                          getPlainTextLength(recetaControlada || "");

                        const pastedText =
                          e.clipboardData?.getData("text") || "";

                        // Si el texto pegado supera el máximo, bloquear
                        if (
                          currentLength + pastedText.length >
                          maxChars4
                        ) {
                          e.preventDefault();
                        }
                      }}
                    >

                      <ProRichTextEditor
                        value={recetaControlada || ""}
                        onChange={(html) => {
                          const plainTextLength =
                            getPlainTextLength(html);

                          // Nunca guardar contenido por encima del máximo
                          if (plainTextLength <= maxChars4) {
                            setRecetaControlada(html);
                          }
                        }}
                        placeholder="Referimientos..."
                      />

                      <div className="pro-rich-counter">
                        {Math.max(
                          0,
                          maxChars4 -
                            getPlainTextLength(recetaControlada || "")
                        )}
                        /{maxChars4}
                      </div>

                    </div>
                  </FormGroup>

                  {/* FOOTER */}
                  <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-3">
                    <div
                      className="text-secondary"
                      style={{
                        fontSize: ".85rem",
                      }}
                    >
                      Puede incluir indicaciones, observaciones y
                      detalles clínicos relevantes.
                    </div>
                  </div>
                </div>
              </div>
              {/* Recetas Controlada */}

              <div
                className="tabGb d-flex flex-column flex-md-row justify-content-center align-items-center gap-3 py-4 px-3 border-top bg-white rounded-bottom"
                style={{
                  minHeight: "8rem",
                  width: "100%",
                }}
              >
                <button
                  onClick={() => CancelConsult()}
                  type="button"
                  className="button-cancel text-secondary shadow-sm"
                  style={{
                    width: "100%",
                    maxWidth: "14rem",
                    height: "3.5rem",
                    borderRadius: "12px",
                    fontWeight: "600",
                    fontSize: "1rem",
                    transition: "all .2s ease-in-out",
                  }}
                >
                  <i className="bi bi-x-circle-fill pe-2"></i>
                  Cancelar
                </button>

                <button
                  onClick={SaveConsult}
                  type="button"
                  className="button-save text-primary shadow-sm"
                  style={{
                    width: "100%",
                    maxWidth: "18rem",
                    height: "3.5rem",
                    borderRadius: "12px",
                    fontWeight: "700",
                    fontSize: "1rem",
                    transition: "all .2s ease-in-out",
                  }}
                >
                  <i className="bi bi-save-fill pe-2"></i>
                  Guardar Consulta
                </button>
              </div>

              <div>
                <Modal
                  isOpen={openModalSaveConsult}
                  toggle={() => setOpenModalSaveConsult(false)}
                  centered
                  backdrop="static"
                  keyboard={false}
                  className="modal-payment"
                  contentClassName="border-0 shadow-lg rounded-4 overflow-hidden"
                  style={{
                    maxWidth: "65rem",
                    width: "95%",
                  }}
                >
                  {/* HEADER */}
                  <ModalHeader
                    toggle={() => setOpenModalSaveConsult(false)}
                    className="border-0 px-4 py-3 bg-primary text-white"
                  >
                    <div className="d-flex align-items-center gap-2">
                      <i className="bi bi-cash-coin fs-4"></i>
                      <span className="fw-bold fs-4">Detalle de Pago</span>
                    </div>
                  </ModalHeader>

                  {/* BODY */}
                  <ModalBody
                    className="bg-light"
                    style={{
                      maxHeight: "85vh",
                      overflowY: "auto",
                    }}
                  >
                    <Form>
                      {/* TOP INFO */}
                      <div className="row g-3 mb-4">

                        {/* LEFT */}
                        <div className="col-lg-6">
                          <div className="bg-white rounded-4 shadow-sm p-4 h-100 border">

                            <div className="d-flex align-items-center mb-3">
                              <i className="bi bi-receipt text-primary fs-4 pe-2"></i>
                              <h5 className="fw-bold mb-0">Información de Facturación</h5>
                            </div>

                            <div className="row g-3">

                              <div className="col-md-6">
                                <FormGroup floating>
                                  <Input
                                    type="text"
                                    value={fechaActual}
                                    disabled
                                  />
                                  <Label>Fecha de Proceso</Label>
                                </FormGroup>
                              </div>

                              <div className="col-md-6">
                                <FormGroup floating>
                                  <Input
                                    type="text"
                                    value={ultimoPay}
                                    disabled
                                  />
                                  <Label>ID Pago</Label>
                                </FormGroup>
                              </div>

                              <div className="col-md-6">
                                <FormGroup floating>
                                  <Input
                                    type="text"
                                    value={ultimaConsultaAll}
                                    disabled
                                  />
                                  <Label>No. Consulta</Label>
                                </FormGroup>
                              </div>

                              <div className="col-md-6">
                                <FormGroup floating>
                                  <Input
                                    type="text"
                                    value={paciente.pcteId}
                                    disabled
                                  />
                                  <Label>Expediente</Label>
                                </FormGroup>
                              </div>

                              <div className="col-12">
                                <FormGroup floating>
                                  <Input
                                    type="text"
                                    value={paciente.seguroNm}
                                    disabled
                                  />
                                  <Label>Seguro Médico</Label>
                                </FormGroup>
                              </div>

                            </div>
                          </div>
                        </div>

                        {/* RIGHT */}
                        <div className="col-lg-6">
                          <div className="bg-white rounded-4 shadow-sm p-4 h-100 border">

                            <div className="d-flex align-items-center mb-3">
                              <i className="bi bi-currency-dollar text-success fs-4 pe-2"></i>
                              <h5 className="fw-bold mb-0">Monto del Pago</h5>
                            </div>

                            <div className="mb-4">
                              <Label className="fw-bold text-secondary mb-2">
                                Total a Pagar
                              </Label>

                              <input
                                className="form-control fw-bold shadow-sm"
                                style={{
                                  width: "100%",
                                  height: "6rem",
                                  fontSize: "3rem",
                                  textAlign: "right",
                                  borderRadius: "20px",
                                }}
                                type="text"
                                placeholder="RD$0.00"
                                value={cantidadPago}
                                onChange={handleChangeCantidadPago}
                                ref={searchInputRef}
                              />
                            </div>

                            <FormGroup floating>
                              <Input
                                type="textarea"
                                name="descripcionPago"
                                id="descripcionPago"
                                placeholder="Descripción"
                                value={descripcionPago}
                                onChange={(e) =>
                                  setDescripcionPago(e.target.value)
                                }
                                style={{
                                  height: "10rem",
                                }}
                                maxLength={maxChars3}
                              />
                              <Label>
                                Descripción del Pago (Opcional)
                              </Label>
                            </FormGroup>

                            <div className="text-end mt-1">
                              <small className="text-muted">
                                {maxChars3 - descripcionPago.length}/{maxChars3}
                              </small>
                            </div>

                          </div>
                        </div>

                      </div>

                      {/* PRINT BUTTON */}
                      <div className="d-flex justify-content-end mb-4">
                        <button
                          type="button"
                          className="btn btn-outline-success rounded-4 px-4 py-3 fw-bold shadow-sm"
                          onClick={() => previsualizarReciboPDF()}
                        >
                          <i className="bi bi-printer-fill pe-2"></i>
                          Imprimir Recibo
                        </button>
                      </div>

                      {/* TABLE */}
                      <div className="bg-white rounded-4 shadow-sm border p-3">

                        <div className="d-flex align-items-center justify-content-between mb-3">
                          <div className="d-flex align-items-center">
                            <i className="bi bi-calendar-check text-primary fs-4 pe-2"></i>
                            <h5 className="fw-bold mb-0">
                              Citas Pendientes del Paciente
                            </h5>
                          </div>

                          <span className="badge bg-primary rounded-pill px-3 py-2">
                            {citasFiltradas.length} pendientes
                          </span>
                        </div>

                        <div
                          className="table-responsive"
                          style={{
                            maxHeight: "20rem",
                            overflowY: "auto",
                          }}
                        >
                          <table className="table table-hover align-middle">
                            <thead
                              className="table-light sticky-top"
                              style={{ zIndex: 1 }}
                            >
                              <tr>
                                <th>Fecha</th>
                                <th>Cita ID</th>
                                <th>Notas</th>
                              </tr>
                            </thead>

                            <tbody>
                              {citasFiltradas.map((cita) => (
                                <tr key={cita.calendarId}>
                                  <td style={{ width: "20%" }}>
                                    {cita.fechaCita.split(" ")[0]}
                                  </td>

                                  <td style={{ width: "15%" }}>
                                    #{cita.calendarId}
                                  </td>

                                  <td
                                    style={{
                                      width: "65%",
                                      textAlign: "left",
                                    }}
                                    title={cita.notaCita}
                                  >
                                    {cita.notaCita &&
                                    cita.notaCita.length > 60
                                      ? `${cita.notaCita.slice(0, 60)}...`
                                      : cita.notaCita}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>

                      </div>
                    </Form>
                  </ModalBody>

                  {/* FOOTER */}
                  <ModalFooter className="border-0 bg-white px-4 py-3">

                    <Button
                      className="button-cancel text-secondary px-4 rounded-3"
                      onClick={() => setOpenModalSaveConsult(false)}
                    >
                      <i className="bi bi-x-circle pe-2"></i>
                      Cerrar
                    </Button>

                    <Button
                      className="button-send text-success px-4 rounded-3 fw-bold"
                      onClick={saveConsultModal}
                      disabled={isSaving}
                    >
                      {isSaving ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                          ></span>
                          Procesando...
                        </>
                      ) : (
                        <>
                          <i className="bi bi-check-circle-fill pe-2"></i>
                          Procesar Pago
                        </>
                      )}
                    </Button>

                  </ModalFooter>
                </Modal>
              </div>
              {/* Buttons Save and Cancel */}
            </Form>
          </Row>
        </div>
        {/* Consulta */}

        {/* Resumen del Paciente  */}
        <div className="">
          {historicoVisible && (
            <div
              className={`historico rounded-end border-start  ${
                historicoVisible ? "transicionWipeLeft" : ""
              }`}
              style={{
                height: historicoVisible ? "100%" : "0",
                width: "35rem",
                backgroundColor: "#fff",
                top: "19rem",
                right: "1rem",
                // overflow: "hidden",
              }}
            >
              <div class="accordion accordion-flush" id="accordionHistorial">
                
                <div className="accordion-item border-0 rounded-4 overflow-hidden shadow-sm">
                  <h2 className="accordion-header" id="flush-headingHistorial">
                    <button
                      className={`accordion-button patient-accordion-btn ${
                        openAccordion === "flush-collapseOne" ? "" : "collapsed"
                      }`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded={
                        openAccordion === "flush-collapseOne" ? "true" : "false"
                      }
                      aria-controls="flush-collapseOne"
                      onClick={() => handleAccordionToggle("flush-collapseOne")}
                    >
                      <div className="d-flex align-items-center gap-2">
                        <i className="bi bi-person-vcard fs-5"></i>
                        <span>Información del Paciente</span>
                      </div>
                    </button>
                  </h2>

                  <div
                    id="flush-collapseOne"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingHistorial"
                    data-bs-parent="#accordionHistorial"
                  >
                    <div className="accordion-body bg-white">

                      <div className="patient-info-container">

                        {/* LABELS */}
                        <div className="patient-info-labels">
                          <label>Número de Documento:</label>
                          <label>Nombre Completo:</label>
                          <label>Número de Contacto:</label>
                          <label>País:</label>
                          <label>Provincia:</label>
                          <label>Municipio:</label>
                          <label>Dirección:</label>
                        </div>

                        {/* VALUES */}
                        <div className="patient-info-values">
                          <span>{paciente.pcteNumDoc}</span>

                          <span>
                            {paciente.pcteNom} {paciente.pcteNom2}{" "}
                            {paciente.pcteApe1} {paciente.pcteApe2}
                          </span>

                          <span>{paciente.pcteCel}</span>

                          <span>{paciente.pcteNac}</span>

                          <span>{paciente.pcteProv}</span>

                          <span>{paciente.pcteCiud}</span>

                          <span className="text-break">
                            {paciente.pcteDir}
                          </span>
                        </div>

                      </div>

                    </div>
                  </div>

                </div>
                {/* Informacion del Paciente */}

                <div className="accordion-item border-0 rounded-4 overflow-hidden shadow-sm">
                  <h2 className="accordion-header" id="flush-headingTwo">
                    <button
                      className={`accordion-button patient-accordion-btn ${
                        openAccordion === "flush-collapseTwo" ? "" : "collapsed"
                      }`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseTwo"
                      aria-expanded={
                        openAccordion === "flush-collapseTwo" ? "true" : "false"
                      }
                      aria-controls="flush-collapseTwo"
                      onClick={() => handleAccordionToggle("flush-collapseTwo")}
                    >
                      <div className="d-flex align-items-center gap-2">
                        <i className="bi bi-clock-history fs-5"></i>
                        <span>Histórico de Atenciones</span>
                      </div>
                    </button>
                  </h2>

                  <div
                    id="flush-collapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingTwo"
                    data-bs-parent="#accordionHistorial"
                  >
                    <div className="accordion-body bg-white">
                      {/* TABLA */}
                      <div className="history-table-container">

                        <table className="table table-hover align-middle">
                          <thead>
                            <tr>
                              <th>Fecha</th>
                              <th>Atención</th>
                              <th>Motivo</th>
                              <th className="text-center">Acción</th>
                            </tr>
                          </thead>
                          <tbody className="text-start">
                            {displayedConsultas.map((consult) => (

                              <tr key={consult.consultId}>
                                <td className="history-date">
                                  {consult.consultFec}
                                </td>
                                <td>
                                  {consult.categoryId && categoryData.length > 0
                                    ? getCategoryName(
                                        consult.categoryId,
                                        categoryData
                                      )
                                    : "Sin categoría"}
                                </td>
                                <td
                                  className="history-motivo"
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  title={getPlainText(consult.consultMot)}
                                >
                                  {getPlainText(consult.consultMot)?.length > 20
                                    ? `${getPlainText(consult.consultMot).slice(0, 20)}...`
                                    : getPlainText(consult.consultMot)}
                                </td>
                                <td className="text-center">
                                  <button
                                    type="button"
                                    className="history-action-btn"
                                    title="Visualizar Consulta"
                                    onClick={() => handleViewDetail(consult)}
                                  >
                                    <i className="bi bi-file-earmark-pdf-fill"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      {/* FOOTER */}
                      <div className="history-footer">
                        <div className="history-pagination">
                          <ReactPaginate
                            pageCount={pageCountConsult}
                            pageRangeDisplayed={3}
                            marginPagesDisplayed={2}
                            onPageChange={handlePageChange}
                            containerClassName={"pagination"}
                            activeClassName={"pagination__link--active"}
                            previousLabel={"<<"}
                            nextLabel={">>"}
                            breakClassName={"break-me"}
                            pageClassName={"page-item"}
                            pageLinkClassName={"pagination__link"}
                            previousClassName={"previous pagination__arrow"}
                            nextClassName={"next pagination__arrow"}
                            pageLinkRenderer={({ page, onPageClick }) => (
                              <a
                                key={page}
                                href="!#"
                                onClick={onPageClick}
                                className={"page-link"}
                              >
                                {page}
                              </a>
                            )}
                          />
                        </div>
                        <div className="history-total">
                          <span>
                            Total de Registros:
                          </span>

                          <strong>
                            {consultas.length}
                          </strong>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* MODAL */}
                  <Modal
                    isOpen={modalOpen}
                    toggle={toggleModal}
                    size="lg"
                    className="history-modal"
                  >

                    <ModalHeader
                      toggle={toggleModal}
                      className="border-0 pb-0"
                    >
                      <div className="d-flex align-items-center gap-2">
                        <i className="bi bi-file-earmark-medical fs-4 text-primary"></i>
                        <span>Detalle Resumido de la Consulta</span>
                      </div>
                    </ModalHeader>

                    <ModalBody>

                      {selectedConsulta && (

                        <div>

                          {/* HEADER */}
                          <div className="history-modal-header">

                            <div className="history-avatar">
                              <i className="bi bi-person-circle"></i>
                            </div>

                            <div className="history-modal-info">

                              <div>
                                <label>No. Expediente:</label>

                                <span>
                                  Exp-{selectedConsulta.consultId}
                                </span>
                              </div>

                              <div>
                                <label>Fecha:</label>

                                <span>
                                  {selectedConsulta.consultFec}
                                </span>
                              </div>

                            </div>

                          </div>

                          {/* CONTENT */}
                          <div className="history-modal-content">

                            <div className="history-detail-card">
                              <strong>Motivo de Consulta</strong>
                              <RichTextDisplay
                                content={selectedConsulta.consultMot}
                              />
                              {/* <p>{selectedConsulta.consultMot}</p> */}
                            </div>

                            <div className="history-detail-card">
                              <strong>Observación</strong>
                              <RichTextDisplay
                                content={selectedConsulta.consultHea || "SIN OBSERVACIÓN"}
                              />
                            </div>

                            <div className="history-detail-card">
                              <strong>Tipo de Diagnóstico</strong>
                             <RichTextDisplay
                                content={selectedConsulta.consultDiag || "SIN DIAGNÓSTICO"}
                             />
                            </div>

                            <div className="history-detail-card">
                              <strong>Clasificación Diagnóstico</strong>
                             <RichTextDisplay
                                content={selectedConsulta.consultClaDiag || "SIN CLASIFICACIÓN"}
                              />
                            </div>

                            <div className="history-detail-card">
                              <strong>CIE-10</strong>
                              <RichTextDisplay
                                content={selectedConsulta.codeCie10 || "SIN ENFERMEDAD"}
                              />
                            </div>

                            <div className="history-detail-card">
                              <strong>Estudio de Gabinete</strong>
                              <RichTextDisplay
                                content={selectedConsulta.estGabinete || "SIN ESTUDIO"}
                              />
                            </div>

                            <div className="history-detail-card">
                              <strong>Resultado de Laboratorio</strong>
                              <RichTextDisplay
                                content={selectedConsulta.resultLab || "SIN RESULTADO"}
                              />
                            </div>

                          </div>

                        </div>

                      )}

                    </ModalBody>

                    <ModalFooter className="border-0">

                      <Button
                        className="button-cancel text-secondary px-4 rounded-3"
                        onClick={toggleModal}
                      >
                        <i className="bi bi-x-circle pe-2"></i>
                        Cerrar
                      </Button>

                    </ModalFooter>

                  </Modal>
                </div>
                {/* Historico de Atenciones */}

                <div className="accordion-item border-0 rounded-4 overflow-hidden shadow-sm">
                  <h2 className="accordion-header" id="flush-headingTre">

                    <button
                      className={`accordion-button patient-accordion-btn ${
                        openAccordion === "flush-collapseTre" ? "" : "collapsed"
                      }`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseTre"
                      aria-expanded={
                        openAccordion === "flush-collapseTre"
                          ? "true"
                          : "false"
                      }
                      aria-controls="flush-collapseTre"
                      onClick={() => handleAccordionToggle("flush-collapseTre")}
                    >
                      <div className="d-flex align-items-center gap-2">
                        <i className="bi bi-file-earmark-medical fs-5"></i>
                        <span>Certificados Médicos</span>
                      </div>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseTre"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingTre"
                    data-bs-parent="#accordionHistorial"
                  >
                    <div className="accordion-body bg-white">
                      {/* TABLA */}
                      <div className="history-table-container">
                        <table className="table table-hover align-middle">

                          <thead>
                            <tr>
                              <th>Fecha</th>
                              <th>Constatado</th>
                              <th>Recomendación</th>
                              <th className="text-center">Acción</th>
                            </tr>
                          </thead>

                          <tbody className="text-start">

                            {displayedCertMedicos.map((certmedicos) => (

                              <tr key={certmedicos.certifiId}>

                                <td className="history-date">
                                  {certmedicos.certifi_fe}
                                </td>

                               <td
                                  className="history-motivo"
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  title={getPlainText(certmedicos.constatado)}
                                >
                                  {truncatePlainText(certmedicos.constatado, 45)}
                                </td>

                                <td
                                  className="history-motivo"
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  title={getPlainText(certmedicos.recomedacion)}
                                >
                                  {truncatePlainText(certmedicos.recomedacion, 45)}
                                </td>

                                <td className="text-center">

                                  <button
                                    type="button"
                                    className="history-action-btn"
                                    title="Visualizar Certificado"
                                    onClick={() =>
                                      handleViewCertificado(certmedicos)
                                    }
                                  >
                                    <i className="bi bi-file-earmark-pdf-fill"></i>
                                  </button>

                                </td>

                              </tr>

                            ))}

                          </tbody>

                        </table>
                      </div>

                      {/* FOOTER */}
                      <div className="history-footer">

                        <div className="history-pagination">

                          <ReactPaginate
                            pageCount={pageCountCertMedicos}
                            pageRangeDisplayed={3}
                            marginPagesDisplayed={2}
                            onPageChange={handlePageChangeCertMedicos}
                            containerClassName={"pagination"}
                            activeClassName={"pagination__link--active"}
                            previousLabel={"<<"}
                            nextLabel={">>"}
                            breakClassName={"break-me"}
                            pageClassName={"page-item"}
                            pageLinkClassName={"pagination__link"}
                            previousClassName={"previous pagination__arrow"}
                            nextClassName={"next pagination__arrow"}
                            pageLinkRenderer={({ page, onPageClick }) => (
                              <a
                                key={page}
                                href="!#"
                                onClick={onPageClick}
                                className={"page-link"}
                              >
                                {page}
                              </a>
                            )}
                          />

                        </div>

                        <div className="history-total">

                          <span>Total de Registros:</span>

                          <strong>
                            {certmedicos.length}
                          </strong>

                        </div>

                      </div>

                    </div>

                  </div>

                  {/* MODAL */}
                  <Modal
                    isOpen={modalCertificadoOpen}
                    toggle={toggleModalCertificado}
                    size="lg"
                    className="history-modal"
                  >

                    <ModalHeader
                      toggle={toggleModalCertificado}
                      className="border-0 pb-0"
                    >

                      <div className="d-flex align-items-center gap-2">
                        <i className="bi bi-file-earmark-medical-fill fs-4 text-success"></i>
                        <span>Detalle del Certificado Médico</span>
                      </div>

                    </ModalHeader>

                    <ModalBody>

                      {selectedCertificado && (

                        <div>

                          {/* HEADER */}
                          <div className="certificate-modal-header">

                            <div className="history-avatar">
                              <i className="bi bi-clipboard2-pulse-fill"></i>
                            </div>

                            <div className="history-modal-info">

                              <div>
                                <label>No. Certificado:</label>

                                <span>
                                  {selectedCertificado.certifiId}
                                </span>
                              </div>

                              <div>
                                <label>Fecha:</label>

                                <span>
                                  {selectedCertificado.certifi_fe}
                                </span>
                              </div>

                            </div>

                          </div>

                          {/* CONTENT */}
                          <div className="history-modal-content">

                            <div className="history-detail-card">
                              <strong>Constatado</strong>
                              {selectedCertificado.constatado ? (
                                <div
                                  className="history-rich-content"
                                  dangerouslySetInnerHTML={{
                                    __html: selectedCertificado.constatado,
                                  }}
                                />
                              ) : (
                                <p>SIN INFORMACIÓN</p>
                              )}
                            </div>

                            <div className="history-detail-card">
                              <strong>Recomendación Médica</strong>
                              {selectedCertificado.recomedacion ? (
                                <div
                                  className="history-rich-content"
                                  dangerouslySetInnerHTML={{
                                    __html: selectedCertificado.recomedacion,
                                  }}
                                />
                              ) : (
                                <p>SIN RECOMENDACIÓN</p>
                              )}
                            </div>

                          </div>

                        </div>

                      )}

                    </ModalBody>

                    <ModalFooter className="border-0">

                      {/* BOTÓN FUTURO */}
                      {/* 
                      <Button
                        className="button-save text-success"
                        onClick={previsualizarPDFCertificados}
                      >
                        <i className="bi bi-printer-fill pe-2"></i>
                        Imprimir
                      </Button>
                      */}

                      <Button
                        className="button-cancel text-secondary px-4 rounded-3"
                        onClick={toggleModalCertificado}
                      >
                        <i className="bi bi-x-circle pe-2"></i>
                        Cerrar
                      </Button>

                    </ModalFooter>

                  </Modal>
                </div>
                {/* Historico de Certificados */}

               <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingFour">
                    <button
                      className={`accordion-button patient-accordion-btn ${
                        openAccordion === "flush-collapseFour" ? "" : "collapsed"
                      }`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseFour"
                      aria-expanded={
                        openAccordion === "flush-collapseFour"
                          ? "true"
                          : "false"
                      }
                      aria-controls="flush-collapseFour"
                      onClick={() => handleAccordionToggle("flush-collapseFour")}
                    >
                      <div className="d-flex align-items-center gap-2">
                        <i className="bi bi-capsule-pill fs-5"></i>
                        <span>Recetas Médicas</span>
                      </div>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseFour"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingFour"
                    data-bs-parent="#accordionHistorial"
                  >
                    <div className="accordion-body">
                      {/* TABLA */}
                      <div className="row g-3">
                        <div className="col-12">
                          <div className="history-table-container">
                            <table className="table table-hover align-middle history-table">
                              <thead>
                                <tr>
                                  <th>No. Expediente</th>
                                  <th>Fecha de consulta</th>
                                  <th>Medicamentos</th>
                                  <th className="text-center"></th>
                                </tr>
                              </thead>
                              <tbody className="text-start">
                                {displayedRecetas && displayedRecetas.length > 0 ? (
                                  displayedRecetas.map((recetaGroup) => {

                                    const consultIdReceta = Number(recetaGroup[0].consultId);

                                    const consultaRelacionada = consultas.find(
                                      (consulta) =>
                                        Number(consulta.consultId) === consultIdReceta
                                    );
                                    const nombresMedicamentos = recetaGroup
                                      .map((item) => item.medicNm)
                                      .join(", ");
                                    const fechaConsulta = consultaRelacionada
                                      ? consultaRelacionada.consultFec
                                      : "Sin fecha";
                                    return (
                                      <tr key={consultIdReceta}>
                                        <td>Exp-{consultIdReceta}</td>
                                        <td>{fechaConsulta}</td>
                                        {/* <td
                                          className="text-truncate-custom"
                                          title={nombresMedicamentos}
                                        >
                                          {nombresMedicamentos}
                                        </td> */}
                                         <td
                                          className="text-truncate-custom"
                                          data-bs-toggle="tooltip"
                                          data-bs-placement="top"
                                          title={nombresMedicamentos}
                                        >
                                          {nombresMedicamentos?.length > 18
                                            ? `${nombresMedicamentos.slice(0, 18)}...`
                                            : nombresMedicamentos}
                                        </td>
                                        <td className="text-center">
                                          <button
                                            type="button"
                                            className="button-view"
                                            onClick={() =>
                                              handleVerRecetaClick({
                                                recetas: recetaGroup,
                                                fechaConsulta,
                                                consultId: consultIdReceta,
                                              })
                                            }
                                          >
                                            <i className="bi bi-eye-fill"></i>
                                          </button>
                                        </td>
                                      </tr>
                                    );
                                  })
                                ) : (
                                  <tr>
                                    <td colSpan="4">
                                      No hay datos disponibles
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>

                          {/* PAGINACIÓN */}
                          <div className="history-pagination">
                            <ReactPaginate
                              pageCount={pageCountRecetasMedicos}
                              pageRangeDisplayed={3}
                              marginPagesDisplayed={2}
                              onPageChange={handlePageChangeRecetaMedicos}
                              containerClassName={"pagination"}
                              activeClassName={"pagination__link--active"}
                              previousLabel={"<<"}
                              nextLabel={">>"}
                              breakClassName={"break-me"}
                              pageClassName={"page-item"}
                              pageLinkClassName={"pagination__link"}
                              previousClassName={"previous pagination__arrow"}
                              nextClassName={"next pagination__arrow"}
                              pageLinkRenderer={({ page, onPageClick }) => (
                                <a
                                  key={page}
                                  href="!#"
                                  onClick={onPageClick}
                                  className={"page-link"}
                                >
                                  {page}
                                </a>
                              )}
                            />
                            <label className="history-total-label">
                              Total de Registros: {recetasAgrupadas.length}
                            </label>

                          </div>
                        </div>
                      </div>

                      {/* VISOR STICKY */}
                      {recetaActiva && (
                        <div className="recipe-viewer">

                          <div className="recipe-viewer-header">

                            <h6 className="mb-0 fs-5">
                              🧾 Detalles de la Receta
                            </h6>

                            <button
                              className="button-delete"
                              onClick={() => setRecetaActiva(null)}
                            >
                              <i className="bi bi-x-lg"></i>
                            </button>

                          </div>

                          <div className="recipe-viewer-body">

                            <div className="recipe-viewer-info">
                              <strong>Expediente:</strong> {recetaActiva.consultId}
                              <br />

                              <strong>Fecha:</strong>{" "}
                              {recetaActiva.fechaConsulta || "Sin fecha"}
                            </div>

                            <table className="table table-sm table-striped text-uppercase">

                              <thead>
                                <tr>
                                  <th>Medicamento</th>
                                  <th>Dosis</th>
                                  <th className="text-center">Total</th>
                                </tr>
                              </thead>

                              <tbody>
                                {recetaActiva.recetas.map((item, index) => (
                                  <tr key={index}>
                                    <td>{item.medicNm}</td>
                                    <td>{item.medicDosis}</td>
                                    <td className="text-center">
                                      {item.medicTotal}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>

                            </table>

                            <div className="text-end mt-3">
                              <button
                                className="button-print"
                                onClick={revisualizarPDF}
                              >
                                <i className="bi bi-printer-fill pe-2"></i>
                                Imprimir Receta
                              </button>
                            </div>

                          </div>
                        </div>
                      )}

                    </div>
                  </div>
               </div>
                {/* Historico Recetas Medicas */}
            </div>
           
            </div>
          )}
        </div>
        {/* Resumen del Paciente  */}
      </div>
    </div>
  );

};
export default ConsultaForm;
